'use client'

import Footer from '@/components/landing-page/footer'
import { Box, Text } from '@chakra-ui/react'
import { Inter } from 'next/font/google'
import './tos.css'

const inter = Inter({
  subsets: ['latin'],
  fallback: ['system-ui'],
})

export default function TermsOfService() {
  return (
    <>
      <div className="bag-white">
        <Box
          margin={'auto'}
          maxW={'92%'}
          position={'relative'}
          className="w-full"
        >
          <div className={`tos-content ${inter.className}`}>
            <Text as="h1" className="tos-title">
              LYKSTAGE TERMS OF SERVICE
            </Text>

            <>
            <p
              className="MsoNormal"
              style={{
                textAlign: 'justify',
                lineHeight: '150%',
                fontSize: '16px',
                fontWeight: '400',
              }}
            >
              <span>
                These Lykstage Terms of Service (Hereinafter referred to as the
                “Agreement”/ “Terms”/ “Service Terms”) shall come into effect
                from <b>28.10.2026</b> (“<b>Effective Date</b>”) and shall apply
                to all the users of the <b>LYKSTAGE Platform </b>(hereinafter
                referred to as the “<b>Platform</b>”/ “<b>Service</b>”) who
                click on{' '}
                <span>
                  “<b>I Agree</b>”{' '}
                </span>
                below.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                This LYKSTAGE Platform is in the sole control of <b>LYK Inc</b>,
                a Delaware corporation, with its registered office at 913 N. Market Street, Suite 300, Wilmington, DE 19801.
                (Hereinafter referred to as “<b>Company</b>” which expression
                shall include its successors and permitted assigns) along with
                the wholly owned subsidiaries based in any of the jurisdictions.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                By clicking the “I Agree” button or accessing, using or
                installing the LYKSTAGE Platform in whole or in part, the User
                expressly agrees to and consents to be bound by all of the
                Terms. If the User does not agree to the Terms so put forth, the
                button indicating “I Disagree” must be selected. The LYKSTAGE
                Platform will promptly cancel these Terms of Service and block
                the access to the Services offered in whole.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                <b>DEFINITION AND INTERPRETATION</b>
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                The terms used in this Agreement shall be interpreted according
                to the meaning stated herein. If any of the terms is not defined
                explicitly here, the meaning mentioned in a dictionary shall be
                taken into consideration. Please note that the headers and
                sidebar text are provided only to make these terms easier to
                read and understand for everyone. The fact that we wrote these
                terms won&apos;t affect the way the Agreement is interpreted.
              </span>
            </p>
            <ol style={{ marginTop: '0in' }} start={1}>
              <li
                className="MsoNormal"
                style={{ textAlign: 'justify', lineHeight: '150%' }}
              >
                <b>
                  <span>1. Advertisements </span>
                </b>
                <span>
                  shall include without limitation any promotional activity
                  displayed on the Platform through the process described
                  hereunder in this Agreement.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ textAlign: 'justify', lineHeight: '150%' }}
              >
                <b>
                  <span>2. Applicable Laws </span>
                </b>
                <span>
                  shall mean and include all the relevant laws of the land where
                  the Services are availed specifically related to but not
                  limited to advertisement laws, privacy and data transmission
                  laws, monetization laws, etc.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ textAlign: 'justify', lineHeight: '150%' }}
              >
                <b>
                  <span>3. Branded Content </span>
                </b>
                <span>
                  shall include without limitation paid product placements,
                  endorsements, and sponsorships that may be displayed in the
                  Content uploaded by the Users.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ textAlign: 'justify', lineHeight: '150%' }}
              >
                <b>
                  <span>4. Content </span>
                </b>
                <span>
                  is defined Clause 6<b>.</b>
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ textAlign: 'justify', lineHeight: '150%' }}
              >
                <b>
                  <span>5. Monetized Watch Time Unit </span>
                </b>
                <span>is defined in Clause 8.</span>
              </li>
              <li
                className="MsoNormal"
                style={{ textAlign: 'justify', lineHeight: '150%' }}
              >
                <b>
                  <span>6. Premium Play Content </span>
                </b>
                <span>
                  shall mean and include any Content uploaded by the User for
                  which the other Users shall pay a price, as determined by the
                  Content Creator while uploading the Content, in order to
                  access it<b>.</b>
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ textAlign: 'justify', lineHeight: '150%' }}
              >
                <b>
                  <span>7. Platform </span>
                </b>
                <span>
                  shall refer to the website of LYKSTAGE
                  (https://www.lykstage.com) and any related mobile application
                  where the Services are offered by the Company.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ textAlign: 'justify', lineHeight: '150%' }}
              >
                <b>
                  <span>8. Services </span>
                </b>
                <span>
                  shall include showcasing videos about different genres,
                  allowing the Users to post or upload videos on the Platform,
                  allowing them to react on the videos posted, through likes,
                  comments and letting them share such videos on various other
                  platforms, providing advertisement services, and any other
                  services offered to the Users in the future.{' '}
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ textAlign: 'justify', lineHeight: '150%' }}
              >
                <b>
                  <span>9. Subscription Plan </span>
                </b>
                <span>
                  shall mean and include the User&apos;s subscription to the
                  Platform&apos;s subscription tiers as shall be laid down
                  within these Terms. The Subscription Plan shall be primarily
                  for the Users who wish to upload Content on the Platform as
                  Creators.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ textAlign: 'justify', lineHeight: '150%' }}
              >
                <b>
                  <span>10. User/s</span>
                </b>
                <span>
                  {' '}
                  is the individual or an entity that visits this Platform in
                  order to use the Services.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ textAlign: 'justify', lineHeight: '150%' }}
              >
                <b>
                  <span>
                    <span className="msoIns">
                      <ins>11. Lykstage AI Model</ins>
                    </span>
                  </span>
                </b>
                <span style={{ fontWeight: 'bold !msorm' }}>
                  <span>
                    <span className="msoIns">
                      <ins>
                        &nbsp; shall mean and include the Artificial
                        Intelligence Model in all its iterations and subsequent
                        versions that is developed solely for the purpose of
                        providing the Platform&apos;s services more efficiently
                      </ins>
                    </span>
                  </span>
                </span>
              </li>
            </ol>
            <h2 style={{ textAlign: 'justify', lineHeight: '150%' }}>
              <b>DISCLAIMER</b>
            </h2>

            <p
              className="MsoNormal"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                Please read this disclaimer carefully before using the LYKSTAGE
                website and platform. By accessing and using the website and
                platform, the User expressly agrees to be bound by the Terms and
                Conditions. If the User does not agree with any part of these
                Terms and Conditions, the User may refrain from using the
                services.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpFirst tos-disclaimer-heading"
              style={{
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                1.
                <span> </span>
              </span>
              <b>
                <span>Voluntary Use of Platform:</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                The use of the website and Platform is entirely voluntary. The
                User acknowledges that they are accessing and using the services
                at their own wish and discretion.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle tos-disclaimer-heading"
              style={{
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  2.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>User Consent to Terms of Service:</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                By accessing and using the website and Platform, the User
                expressly consents to our Terms of Service. The User has read
                and understood these terms &amp; conditions in the desired
                language from a list of 22 (twenty-two) or more languages
                offered on the Platform. This consent is a legally binding
                agreement between the User and LYKSTAGE, and it governs the use
                of services.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle tos-disclaimer-heading"
              style={{
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  3.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Changes to Terms of Service:</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                The Platform may modify or update these Terms of Service as described in Clause 32.
                The Platform will notify Users of material changes through an in-app notice and by
                email (if the User has provided one) at least 30 days before the changes take effect.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle tos-disclaimer-heading"
              style={{
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  4.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>User Responsibility for Updated Terms of Services:</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                The updated Terms of Service will be posted on this page with a new
                Effective Date. If the User continues to use the website and Platform
                after a material change takes effect, the revised Terms of Service
                apply to the User. Continued use will not be treated as consent to
                any new use of the User's information that requires consent under applicable law.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle tos-disclaimer-heading"
              style={{
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  5.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Discontinuation of Use:</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                If the User does not agree with any updated Terms of Service or
                Privacy Policy, they have the option to discontinue using the
                website and Platform. If they continue to use the services after
                any changes to the Terms of Service or Privacy Policy take effect,
                the revised terms apply as described in item 4 above.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle tos-disclaimer-heading"
              style={{
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  6.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Legal Effect of Terms of Service:</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                The User&apos;s consent to the Terms of Service creates a
                legally binding agreement between the User and LYKSTAGE. If they
                are using our Platform on behalf of an organization or entity,
                they represent that they have the authority to bind that
                organization or entity to the Terms of Service.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle tos-disclaimer-heading"
              style={{
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  7.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>No Waiver of Rights:</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                The failure of LYKSTAGE to enforce any provision of the Terms of
                Service does not constitute a waiver of such provision or any
                other provision.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle tos-disclaimer-heading"
              style={{
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  8.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Severability:</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                If any provision of these Terms of Service is found to be
                unenforceable or invalid by a court of competent jurisdiction,
                the remaining provisions of the Terms of Service shall remain in
                full force and effect.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle tos-disclaimer-heading"
              style={{
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  9.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Conclusion:</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpLast"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                By using the website and Platform, the User agrees to the above
                disclaimer and the terms set forth in the following Terms of
                Service. If the User has any questions or concerns regarding the
                services or the disclaimer, please feel free to contact the
                Platform&apos;s Team at info@lykstage.com. Thank you for using
                LYKSTAGE.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                The User hereby unconditionally and with free consent agrees to
                the following terms mentioned herein:
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpFirst"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  1.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Eligibility of the User</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                1.1.
                <span> </span>
              </span>
              <span>
                Minimum age:- The User must be at least 13 years of age to use the Platform. The User must be at least 18 years of age to verify their identity, redeem LYK Coins, or receive any Watch-2-Earn reward, payout or creator monetisation, including in the United Arab Emirates.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                1.2.
                <span> </span>
              </span>
              <span>Permission from the parents or lawful guardians:-</span>
              <span style={{ color: 'black' }}></span>
              <span>
                {' '}If the User is located in India and is under 18 years of age,
                the User may use the Platform only with the verifiable consent
                of a parent or lawful guardian, and under their guidance.
                For such Users, the Platform does not show personalised advertising,
                does not use the User's location for personalisation or advertising,
                does not track or monitor the User's behaviour for advertising, and
                does not offer Watch-2-Earn rewards or LYK Coins. The Company is not
                under an obligation to guarantee that the Content showcased here
                are children/minor friendly.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                1.3.
                <span> </span>
              </span>
              <span>
                Health:- The user shall be mentally and physically stable and
                shall be in a position to understand the functioning of this
                Platform. People who are intoxicated or mentally challenged,
                shall not use this Platform independently.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  2.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Applicable Terms</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                Please read this Agreement carefully and make sure you
                understand it. If the User does not understand the Agreement, or
                does not accept any part of it, then they may not use the
                Service.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  3.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Minimum System Requirements</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                3.1.
                <span> </span>
              </span>
              <span>
                Use of the Service requires access to the internet network and
                compliance with the appropriate configuration requirements.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                3.2.
                <span> </span>
              </span>
              <span>
                As the provision of these configuration requirements is not
                included in the Service, the User shall be personally
                responsible for obtaining such access from the appropriate
                operator freely chosen by the User and under the User&apos;s
                responsibility. The User declares that the User knows and
                accepts these configuration constraints and undertakes to comply
                with them.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                3.3.
                <span> </span>
              </span>
              <span>
                The Company declines all responsibility and will have no
                obligation to refund, in the event of non-functioning of the
                Service or any of the Platform&apos;s features due to lack of
                connectivity to the internet or lack of respect for the system
                requirement.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  4.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>User Account</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.1.
                <span> </span>
              </span>
              <span>
                The User shall be given an option to create a User Account as an
                individual or for a business.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.
                <span> </span>
              </span>
              <span>
                The Company shall collect the following data, not being limited
                to mentioned below of the Users in order to register the User
                Account for the same:-
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.1.<span> </span>
              </span>
              <span>Name of the user</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.2.<span> </span>
              </span>
              <span>
                Contact details of the user – which shall include their Phone
                Number and/or E-Mail ID
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.3.<span> </span>
              </span>
              <span>
                Contact details of the business in cases where the User Account
                is getting created for a business.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.4.<span> </span>
              </span>
              <span>Age</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.5.<span> </span>
              </span>
              <span>
                Display/profile picture&amp; Cover picture. If these pictures
                are found to be in violation of public policy or any of the
                applicable laws and regulations then the Platform shall have the
                sole discretion of pulling down such pictures with immediate
                effect.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.6.<span> </span>
              </span>
              <span>
                Preferences of the User in terms of genres on the basis of which
                videos will be recommended to the User.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.7.<span> </span>
              </span>
              <span>
                Accurate Banking Information as needed, the User shall ensure
                that their bank account is able to receive the international
                payments.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.8.<span> </span>
              </span>
              <span>Accurate Taxation Information as and when needed.</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.9.<span> </span>
              </span>
              <span>
                The automatic payment information to be provided to the Platform
                to determine the Subscription Plan.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.10.<span> </span>
              </span>
              <span>
                Account and device identifiers, including mobile
                advertising identifiers where the User permits them.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.11.<span> </span>
              </span>
              <span>
                Usage information, such as the Content viewed, watch time,
                and interactions with Content and advertisements.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.12.<span> </span>
              </span>
              <span>
                Searches the User runs on the Platform.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.13.<span> </span>
              </span>
              <span>
                Approximate location, as described in Clause 4.14.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.14.<span> </span>
              </span>
              <span>
                Identity verification information, including PAN or an
                equivalent national or tax identifier and, where the User
                chooses, government identity documents retrieved through
                DigiLocker, collected before the User can redeem LYK Coins
                or receive a payout.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.2.15.<span> </span>
              </span>
              <span>
                The information the Company collects, the purposes for which
                it is used, and how long it is kept are described in full in
                the Privacy Policy.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.3.
                <span> </span>
              </span>
              <span>
                Upon submitting the above mentioned information, the User shall
                be asked to create a username and password which may be stored
                with the Company till the time the user account is not suspended
                or the User voluntarily does not delete the user account.
                Regardless of this, the Company shall also be able to exercise
                the retention of data based upon the regulation of the country
                from where the data is collected.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.4.
                <span> </span>
              </span>
              <span>
                The User shall also have the option to select the Subscription
                Plan at any point of their use of the Platform which shall be as
                follows:
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.4.1.<span> </span>
              </span>
              <span>Lykstage Free Subscription</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.4.2.<span> </span>
              </span>
              <span>Lykstage Plus Subscription</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.4.3.<span> </span>
              </span>
              <span>Lykstage Pro Subscription</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.5.
                <span> </span>
              </span>
              <span>
                The User shall be allowed to amend any kind of details, username
                and password and the same shall be noted and stored by the
                Company.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.6.
                <span> </span>
              </span>
              <span>
                Upon creation of the User Account, The User shall receive LYK
                Coins.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.7.
                <span> </span>
              </span>
              <span>
                The User shall confirm the number of Lyk Coins received as per
                their jurisdiction which will be mentioned in the earnings
                section. This denomination may change based upon the discretion
                of the Platform. The same shall reflect in the Earnings Section.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.8.
                <span> </span>
              </span>
              <span>
                Sign In: For sign-in process, the User shall be asked to enter
                either registered mobile number or E-Mail ID along with the
                password. The Platform provides an option to allow the Platform
                to remember the password for making the overall sign-in process
                convenient.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.9.
                <span> </span>
              </span>
              <span>
                Details about the Users can be collected through the following
                methods:
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.9.1.<span> </span>
              </span>
              <span>
                Through the Users directly - During the process of user account
                registration, the User can manually enter and give all the
                details to the Company.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.9.2.<span> </span>
              </span>
              <span>
                Through third-party associated websites/platforms - The User can
                allow the Company to borrow the details from the associated
                third party websites including but not limited to such as
                Google, Apple, etc where the User already have a user account.
                Please note that the Company shall not be held liable for any
                inaccuracy in the details collected through such medium. The
                User shall be responsible to verify the data provided. The
                Company shall be allowed to record and store the process in
                which the data was collected.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.10.
                <span> </span>
              </span>
              <span>
                The Types of Users that can register themselves on the Platform:
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.10.1.<span> </span>
              </span>
              <span>
                {' '}
                Viewers: The Users that shall be primarily viewing content, the
                Users uploading any content can also be viewers. The Viewers
                shall also have the option to subscribe to the channels created
                by the Users who are creators.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.10.2.<span> </span>
              </span>
              <span>
                Creators: The Users that shall be creating content. The Users
                creating content shall also be able to view other Users&apos;
                content. The Creators shall be of two types:
              </span>
              <ol className="olTypei">
                <li>
                  <strong>Individual Creators:</strong> who shall be creating
                  content independently as individuals; and
                </li>
                <li>
                  <strong>Business Creators:</strong> creating accounts to
                  represent businesses and different organizations. The Business
                  Creators have to choose their industry while registering with
                  LYKSTAGE. The Business Creators are further divided into two
                  types:
                  <ol className="olTypea">
                    <li>
                      <strong>Broadcasting Content Creators:</strong> The
                      Business Creators that chose their industry as “Media and
                      Entertainment”. The primary content uploaded by such Users
                      shall be Broadcasting Type of Content. These Users shall
                      have access to avail the Live TV Services of the Platform.
                    </li>
                    <li>
                      <strong>Non-Broadcasting Content Creators:</strong> The
                      Business Creators that upload all kinds of content aside
                      from Broadcasting Type Content.
                    </li>
                    <li>
                      <strong>Note:</strong> It is to be noted that only the
                      Broadcasting Content Creators shall have access to the
                      Live TV Services offered by the Platform.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>All Creators</strong> eligible for earnings by the way
                  of rewards must note that their eligibility for the rewards is
                  contingent on the jurisdiction in which their Content will be
                  viewed. This is further elaborated in Clause 8: Reward System.
                </li>
                <li>
                  <strong>All Creators</strong> shall also have the access to
                  the Creator Dashboard which shall have all the information in
                  relation to their earnings, video watch time, Lyk Coins earned
                  and so on by the Creators.
                </li>
              </ol>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  4.11.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Purpose of Collection of Data by the Platform:</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.11.1.<span> </span>
              </span>
              <span>
                There are certain purposes behind data collection by the
                Platform which are as mentioned below, not being limited to:-
              </span>

              <ol className="olTypei">
                <li>
                  To determine the User being a genuine User that helps the
                  Platform in identifying any bot or fake accounts being tried
                  to setup right at the registration stage.
                </li>
                <li>
                  To be in compliance with the applicable laws of the land that
                  mandates the Platform to collect and store the data.
                </li>
                <li>
                  To use the metadata and other content related information,
                  with due consent of the User, associated with the Content for
                  the training and development of the Lykstage AI Model. All
                  such data shared with third party service providers is
                  anonymized or pseudonymized before sharing, ensuring no
                  personal information of the User is disclosed.
                </li>
                <li>
                  To analyze the User preferences and suggest them the Content
                  that they may like.
                </li>
                <li>
                  To provide the data to the affiliated third parties such as
                  the appointed payment aggregator and payment gateway entities
                  so that they can provide their services on the Platform more
                  conveniently.
                </li>
                <li>
                  To detect, prevent, and respond to fraudulent activities,
                  abuse of the Service, intellectual property violations, and
                  any breaches of the Platform&apos;s Terms of Use or applicable
                  laws.
                </li>
                <li>
                  To carry out internal research, product testing, diagnostics,
                  and analytical functions aimed at developing new features and
                  improving system reliability and user safety.
                </li>
                <li>
                  To fulfil taxation and other transparency related obligations
                  as and when they arise.
                </li>
              </ol>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.11.2.<span> </span>
              </span>
              <span>
                AI-Assisted Optimization of Titles and Descriptions
              </span>

              <ol className="olTypei">
                <li>
                  LYKSTAGE uses artificial intelligence ("LYKSTAGE AI") to help improve the discoverability of content uploaded to the platform. By accepting these Terms of Service and uploading content, you consent to LYKSTAGE AI optimizing and updating the title and, where appropriate, the description of your content from time to time to improve its visibility and reach across search engines and through search engine optimization (SEO).
                </li>
                <li>
                  This functionality is intended solely to enhance the discoverability of your content while preserving its overall context and intent. It applies only to the title and, where appropriate, the description, and does not alter your underlying video or audio content. LYKSTAGE will not use this feature to misrepresent the substance or meaning of your content.
                </li>
                <li>
                  You acknowledge that LYKSTAGE AI may make such updates automatically and on an ongoing basis. LYKSTAGE does not guarantee any particular level of search ranking, traffic, views, or revenue resulting from these optimizations. You remain responsible for the content you publish and for ensuring it complies with these Terms, the Community Guidelines, and applicable law.
                </li>
              </ol>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  4.12.
                  <span></span>
                </span>
              </b>
              <b>
                <span>Parental Control</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.12.1.
                <span> </span>
              </span>
              <span>
                Parental control shall be enabled by the parents or the
                lawful guardians of a User located in India who is under
                18 years of age, as described in Clause 1.2.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.12.2.
                <span> </span>
              </span>
              <span>
                In such case, the details given while creating a user account
                shall be of the parents or the lawful guardians and not of the
                user.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.12.3.
                <span> </span>
              </span>
              <span>
                The parents or the lawful guardians shall abide by the usage
                limit set by the Company in such situation.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.12.4.
                <span> </span>
              </span>
              <span>
                The parents or the lawful guardians shall monitor and take
                utmost responsibility of the genre of the videos watched by the
                user not be inappropriate considering the age and shall also
                restrict the usage time for the best interest of the user.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>4.13.</span>
              <span>Use of the Platform without a User Account</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.13.1.
                <span> </span>
              </span>
              <span style={{ color: 'black' }}>
                The Users shall not be under a mandatory obligation to create a
                user Account. Certain services can be availed to the User even
                without a User Account. However, there shall be certain
                restrictions applied on the usage.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.13.2.
                <span> </span>
              </span>
              <span style={{ color: 'black' }}>
                The User shall be able to watch the videos posted on the
                Platform but shall not be able to upload videos on the Platform,
                the user shall see and be directed to third party websites
                through advertisements posted on the Platform, but the user
                shall not be able to apply for advertisement services on the
                Platform.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.13.3.
                <span> </span>
              </span>
              <span>
                The Company may apply any restrictions on such Users as the
                Company may deem fit from time to time.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>4.14.</span>
              <span>Location</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.14.1.
                <span> </span>
              </span>
              <span style={{ color: 'black' }}>
                The Platform uses approximate location derived from the
                User's IP address to comply with regional content licensing,
                to determine whether the Service and its features
                (including monetisation) are available in the User's
                country, and to detect fraud.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.14.2.
                <span> </span>
              </span>
              <span style={{ color: 'black' }}>
                If the User allows the LYKSTAGE mobile application to access their
                location, the application collects approximate location only, not
                precise (GPS-level) location. The Platform uses it to show the User
                content from near them, to confirm which features and content are
                available in the User's country, and to make advertising more relevant.
                Device location is stored with the User Account.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.14.3.
                <span> </span>
              </span>
              <span>
                The User may turn off location access at any time in the
                application settings or device settings. When the User does
                so, the Platform stops collecting device location and deletes
                the stored device location within 30 days.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                4.14.4.
                <span> </span>
              </span>
              <span>
                The Platform does not share the User's location with Social Gear Inc.
                or any other affiliate to build audiences or show advertising outside
                LYKSTAGE, and will not start doing so without notifying the User in
                advance and giving the User a way to opt out.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  5.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Use of Account by the User</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                5.1.
                <span> </span>
              </span>
              <span>
                The User may use the Account primarily for viewing content for
                entertainment purposes.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                5.2.
                <span> </span>
              </span>
              <span>
                The Users may promote, administer, or conduct a promotion on,
                through, or utilizing the Platform Services (a “Promotion”),
                provided that if they choose to do so, they may carry out
                Promotions to the extent permitted by applicable law and the
                Users are solely responsible for ensuring that any Promotions
                comply with any and all Applicable Laws, obligations, and
                restrictions.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                5.3.
                <span> </span>
              </span>
              <span>
                The Company is not responsible for and does not endorse or
                support any such Promotions. The User may not indicate that the
                Company is a sponsor or co-sponsor of the Promotion. The User
                will display or read out the following disclaimer when
                promoting, administering, or conducting a Promotion: “This is a
                promotion by [Your Name]. LYK Inc or any of its affiliates does
                not sponsor or endorse this promotion and is not responsible for
                it.”
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                5.4.
                <span> </span>
              </span>
              <span>
                Subject to this Agreement, the User may share political
                opinions; participate in political activity; provide links to a
                political committee&apos;s official website, including the
                contribution page of a political committee; and solicit viewers
                to make contributions directly to a political committee. The
                User agrees, however, that these activities are entirely their
                own. Moreover, by engaging in these activities, the User
                represents and warrants that the User is eligible to engage in
                them under Applicable Laws, and that the User shall abide by all
                relevant laws and regulations while doing so.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                5.5.
                <span> </span>
              </span>
              <span>
                In case of whether any User is uploading any Branded Content on
                their Account they agree that the Users are solely responsible
                for ensuring that their Branded Content complies with any and
                all applicable advertising laws, regulations, and guidelines.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  6.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Subscription Plan</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                6.1.
                <span> </span>
              </span>
              <span>
                The Subscription Plan can be chosen by User at any point of
                their use of The Platform.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                6.2.
                <span> </span>
              </span>
              <span>
                The Subscription Plans available to the Users who wish to upload
                Content on the Platform as Creators are as follows:
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                6.2.1.<span> Lykstage Free Subscription:</span>
              </span>
              <ol className="olTypei">
                <li>
                  The Creators shall have access to the basic services of the
                  Platform.
                </li>
                <li>
                  The revenue stream for the Creator shall be by the means of
                  advertisements.
                </li>
                <li>
                  The Creators shall have access to 10 GB of cloud storage to
                  upload their Content.
                </li>
              </ol>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                6.2.2.<span> Lykstage Plus Subscription:</span>
              </span>
              <ol className="olTypei">
                <li>
                  The Creators shall have access to the basic services of the
                  Platform and shall have the option to create password
                  protected Content.
                </li>
                <li>
                  The revenue stream for the Creator shall not only be by the
                  means of advertisements but also through the means of Premium
                  Play Content as shall be described in these terms.
                </li>
                <li>
                  The Creators shall have access to 100 GB of cloud storage to
                  upload their Content.
                </li>
              </ol>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                6.2.3.<span> Lykstage Pro Subscription:</span>
              </span>
              <ol className="olTypei">
                <li>
                  The Creators shall have access to the basic services of the
                  Platform and shall have the option to create password
                  protected Content.
                </li>
                <li>
                  The revenue stream for the Creator shall not only be by the
                  means of advertisements but also through the means of Premium
                  Play Content as shall be described in these terms.
                </li>
                <li>
                  The Creators shall have access to 2 TB of cloud storage to
                  upload their Content.
                </li>
              </ol>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                6.2.4.
                <span>
                  {' '}
                  The User shall enjoy the benefits of their Subscription Plan
                  during the billing cycle which may be either monthly or
                  annually.
                </span>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                6.2.5.
                <span>
                  {' '}
                  The pricing of the Subscription Plans can be accessed through
                  account. The prices for the Subscription Plans shall vary as
                  per the discretion of the Company.
                </span>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                6.2.6.
                <span>
                  {' '}
                  The fee paid for the Subscription Plan is non-refundable and
                  shall not be returned to the User under any circumstances. In
                  case the User moves to a lower tier of the Subscription Plans
                  they shall lose the privileges of the higher tier at the end
                  of the billing cycle.
                </span>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                6.2.7.
                <span>
                  {' '}
                  Violation of these terms may result in the cancellation of the
                  User&apos;s subscription plan.
                </span>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  7.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Content and Services Offered</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.1.
                <span> </span>
              </span>
              <span>Types of Content on the Platform</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.1.1.<span> </span>
              </span>
              <span>
                The Content posted on the Platform includes videos, audio (for
                example music and other sounds), graphics, photos, text (such as
                comments and scripts), branding (including trade names,
                trademarks, Service marks, or logos), interactive features,
                software, metrics, and other materials (collectively, “
                <b>Content</b>”).
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.1.2.<span> </span>
              </span>
              <span>
                Content uploaded shall be provided as a Service to the other
                Users on the Platform. Content is the responsibility of the User
                that uploads it on the Platform. The Types of Content that can
                be viewed and uploaded on the Platform are:
              </span>
              <ol className="olTypei">
                <li>
                  <strong>Regular:</strong> The User may select this option
                  where the Content is a pre-recorded Content and the same is
                  needed to be uploaded on the Platform. The Regular Content is
                  of the following types:
                  <ol className="olTypea">
                    <li>
                      <strong>Free Content:</strong> The kind of Content that
                      shall be available to be viewed free of cost and shall be
                      monetized according to the Platform&apos;s reward system.
                      The Free Content can only be viewed or uploaded as long as
                      it meets the Platform&apos;s requirements.
                    </li>
                    <li>
                      <strong>Premium Play Content:</strong> Only the Users
                      bearing subscription to Lykstage Plus or Lykstage Pro
                      subscription shall have the option to upload Premium Play
                      Content. The premium fee charged, shall be determined at
                      the Content Creator&apos;s discretion. The User may set
                      and change the prices for their Content at their
                      discretion through their User account, though no price
                      changes will apply retroactively. If the User chooses to
                      charge a premium fee for their content, they shall agree
                      to the following:
                      <ol className="olTypeI">
                        <li>
                          <strong>No Circumvention:</strong> The User agrees to
                          process payments from the viewers only in the manner
                          determined by the Platform. This includes using the
                          third-party payment processing platform (“Payment
                          Processor”) that the Platform hires, and following any
                          other rules specified by the Platform. The User may
                          not circumvent their payment obligations to the
                          Platform by soliciting payment from a viewer outside
                          of the Platform or by using any alternative method to
                          collect premium fees. This includes without limitation
                          receiving payments for their content on the Platform
                          through links to a separate content platform page
                          altogether. The User of the Platform shall agree to
                          notify the Platform team immediately if they receive
                          any such offer or solicitation to circumvent their
                          payment obligations by contacting{' '}
                          <a href="mailto:legal@lykstage.com">
                            legal@lykstage.com
                          </a>
                          .
                        </li>
                        <li>
                          <strong>Taxes:</strong> The User agrees to bear and be
                          responsible for any and all applicable federal, state,
                          local, and foreign taxes, duties, tariffs, levies,
                          withholdings, and similar assessments as the case may
                          be related to their content.
                        </li>
                        <li>
                          <strong>Revenue Share:</strong> The User shall receive
                          from the Platform at least seventy-five (75) percent
                          of the total amount charged by the User to the Viewers
                          (the “Revenue Share”) after any amounts deducted by
                          the Payment Processor. The Revenue Share percentage is
                          set between the User and LYKSTAGE during registration
                          of the User Account. The Revenue share percentage is
                          contingent on the following of the User on the
                          Platform.
                        </li>
                        <li>
                          <strong>Revenue Share Payment:</strong> During the
                          term of these Terms and Conditions, the Payment
                          Processor shall pay the Revenue Share owed to the
                          Platform on a mutually decided rolling basis as the
                          User processes subscription payments from the viewers.
                          The User agrees to these payments and further agree
                          that all Revenue Share payments are non-refundable.
                        </li>
                        <li>
                          <strong>Information upon Request:</strong> The User
                          will provide the Platform with all requested data or
                          information about the User and/or the User uploaded
                          content. This includes all payment and tax
                          identification information, and the User will ensure
                          this information is accurate and up-to-date.
                        </li>
                        <li>
                          <strong>Viewing Premium Content:</strong> The User
                          downloading Premium Content shall have it downloaded
                          to their library and shall retain the ability to view
                          it for thirty (30) days after downloading the content,
                          post which the User shall have to pay the Premium Fees
                          yet again to access the Premium Play Content. The User
                          shall only have forty-eight (48) hours to view the
                          content after first playing it. After the elapse of
                          the said forty-eight hours, the User shall have to pay
                          the Premium Fees yet again to access the Premium Play
                          Content.
                        </li>
                        <li>
                          <strong>Deletion of Premium Content:</strong> The User
                          who has uploaded Premium Play Content may request the
                          Platform to delete it at any time after upload of the
                          Premium Play Content. Should the Premium Play Content
                          be rented by another User at the time of such request,
                          the Premium Play Content shall only be taken down
                          immediately after the elapse of the rental period. The
                          Premium Play Content shall no longer be available on
                          the Platform immediately on the day of request but it
                          shall only be taken down post the elapse of all the
                          standing rental periods.
                        </li>
                        <li>
                          <strong>Platform Takedown Right:</strong> The Platform
                          shall also have the right to take down the Premium
                          Play Content without intimation to the User should the
                          Content not be rented by at least five (5) Users for a
                          period of thirty (30) days after the uploading of the
                          Premium Play Content.
                        </li>
                      </ol>
                    </li>
                    <li>
                      <strong>Password Protected Content:</strong> The Users
                      bearing the subscription to Lykstage Plus or Lykstage Pro
                      subscriptions shall have a liberty of uploading password
                      protected Content on the Platform. If a User/viewer
                      intends to watch such Content, the same shall request the
                      User who uploaded on the Platform. When a User clicks on
                      password protected Content, a request message shall pop-up
                      on the screen where the viewer may click on the
                      &apos;Request&apos; option. An intimation shall be
                      received by the User who uploaded such Content on the
                      Platform in the notification section and on their
                      registered Email ID. The User, who uploaded, shall have
                      the discretion to approve such request for the same. The
                      User, setting the password for the Content, shall have the
                      option to share the password with the appropriate User who
                      intends to watch it.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Event:</strong> The User may select this option where
                  the User may schedule the upload time of the Content on the
                  Platform. Currently, the User can avail the Live Stream
                  services to upload content under this category.
                </li>
                <li>
                  <strong>Live Stream:</strong>
                  <ol className="olTypea">
                    <li>
                      This option can be availed by any kind of user, i.e.,
                      individual or business user where the User can live
                      telecast an event from one device and telecasting the live
                      visuals on the Platform from another device.
                    </li>
                    <li>
                      Any live streams on the Platform shall be monitored by the
                      Platform. If the Platform finds the content being shown to
                      be violative of any clauses stated herein, applicable laws
                      and regulations, public policy, etc, the Platform shall
                      have the liberty to take strict actions against the User
                      who is uploading such live Content.
                    </li>
                    <li>
                      When the User is streaming live on the Platform they may
                      not simultaneously live stream or broadcast (“Simulcast”)
                      on any other Service or Platform, meaning any web-based
                      network, platform, or service that supports live streaming
                      of user generated content, without advance written
                      permission from the Platform. For clarity, the User may
                      Simulcast on mobile-first services that support live
                      streaming. This Section does not apply to non-profit or
                      government entities that are live streaming for
                      non-commercial purposes.
                    </li>
                    <li>
                      Please note that Live Content does not fall under the
                      monetization scheme of the Platform. Hence, the Content
                      Creator/User uploading such Content shall not be able to
                      generate and collect LYK Coins. Only the viewers of such
                      Content may be able to collect such Coins.
                    </li>
                    <li>
                      It is also to be noted that the User must send an E-Mail
                      to{' '}
                      <a href="mailto:info@lykstage.com">info@lykstage.com</a>{' '}
                      to attain the Platform&apos;s permission to avail the Live
                      Stream Services. The User shall send an email with the
                      subject “REQUEST FOR LIVE STREAM” and elaborate their User
                      ID and their proposed time to Live Stream in the body of
                      the E-Mail. The Platform shall respond to the E-Mail
                      within forty-eight (48) hours of sending the E-Mail.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>Live TV:</strong> This type of content will be
                  available only to the User having a business account that
                  selected the industry of Media and Entertainment on the
                  Platform. The primary format of content on this type of
                  service shall be a broadcasting type content that shall be
                  uploaded by the User. It shall be the sole responsibility of
                  the User to prove ownership of such content. The User shall be
                  bound by the following Conditions for uploading the Live TV
                  Content:
                </li>
              </ol>
            </p>

            <p
              className="MsoNormal"
              style={{
                marginLeft: '0.93in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>LIVE TV TERMS OF SERVICE</span>
              </b>
              <p>
                These Live TV Terms of Service shall be read alongside LYKSTAGE
                Terms of Service and Privacy Policy
              </p>
              <p>
                This LYKSTAGE Platform is in the sole control of LYK Inc,
                Delaware, USA, registered under the Delaware General Corporation
                Law, and having its registered office at 913 N. Market Street,
                Suite 300, Wilmington, DE 19801. (Hereinafter referred to as
                &quot;LYK&quot; which expression shall include its successors
                and permitted assigns).
              </p>
              <p>
                By clicking the &quot;I Agree&quot; button or accessing, using
                or installing the LYKSTAGE Platform in whole or in part, the
                User expressly agrees to and consents to be bound by all of the
                Terms. If the User does not agree to the Terms so put forth, the
                button indicating &quot;I Disagree&quot; must be selected. The
                LYKSTAGE Platform will promptly cancel these Terms of Service
                and block the access to the Services offered in whole.
              </p>

              <ol className="olTypeI">
                <li>
                  <strong>DEFINITIONS</strong>
                  <ul>
                    <li>
                      <strong>&quot;Network&quot;</strong> means any entity that
                      shall have an established audio-visual transmission
                      services of a specific genre in the realm of televised
                      medium and wishes to avail the Live-TV Services of the
                      LYKSTAGE Platform.
                    </li>
                    <li>
                      <strong>&quot;Service/s&quot;</strong> means all the
                      content that will be provided by the Network through the
                      Live-TV Services of the LYKSTAGE
                    </li>
                    <li>
                      <strong>&quot;Affiliate&quot;</strong> means any person or
                      entity that directly or indirectly or through one or more
                      intermediaries, controls or is controlled by, or is under
                      common control with a party to this Agreement; and for the
                      purposes of this definition, the term control (including
                      the words controlling or controlled by) shall mean the
                      power to direct or cause the direction of the management
                      and policies of a person or entity whether through the
                      ownership of voting securities, by contract or otherwise.
                    </li>
                    <li>
                      <strong>&quot;Content&quot;</strong> means each piece of
                      audio and/or video content (including each and every
                      constituent element thereof) as particularly described on
                      Part B.
                    </li>
                    <li>
                      <strong>&quot;Channel(s)&quot;</strong> shall mean and
                      refer to such channel, which is delivered by the Network
                      and/or its Affiliates, the details of which are set forth
                      in Annexure A hereto, and shall include, any SD/HD
                      version, 4K version and any other new versions of such
                      Channel, whether renamed or rebranded subsequently in any
                      manner and any successor channel to the Channel(s) and
                      also includes any channel(s) that will be launched or
                      acquired by the Network and / or its affiliates, after the
                      Effective Date.
                    </li>
                    <li>
                      <strong>
                        &quot;Service Subscriber/Subscriber(s)&quot;
                      </strong>{' '}
                      means any direct customer of LYK who is expressly
                      authorized by LYK to receive the Service and actually
                      receives the Service and that is active and in good
                      standing. Any Service Subscriber who receives the Service
                      from LYK or any of its Affiliates: (A) through more than
                      one (1) distribution technology; (B) to more than one type
                      of device; and/or (C) in more than one package of services
                      shall be included in the Service Subscriber count as only
                      one (1) Service Subscriber. LYK shall be entitled to
                      determine, in its sole discretion, whether a particular
                      Service Subscriber is located in a Residential Location,
                      Commercial Location or is a Bulk-Billed Service
                      Subscriber. Notwithstanding anything else in this
                      Agreement to the contrary, the following shall not be
                      considered a &quot;Service Subscriber&quot;
                      <ol type="a">
                        <li>
                          a. LYK and/or any of its Affiliates&apos; test sites;
                        </li>
                        <li>
                          b. employees of LYK and/or any of its Affiliates;
                        </li>
                        <li>
                          c. any VIP accounts or test sites authorized by LYK at
                          the request of Network (provided that LYK shall not be
                          required to authorize any such accounts or sites);
                        </li>
                        <li>
                          d. person who are receiving the Service without
                          LYK&apos;s express authorization (e.g., so-called
                          &apos;pirates&apos; and parties that provide false or
                          misleading information to LYK at the time of account
                          activation); and
                        </li>
                        <li>
                          e. person receiving the Service from LYK solely as a
                          function of transport and who are paying Network
                          either directly or through an independent third party.
                        </li>
                      </ol>
                    </li>
                  </ul>
                </li>

                <li>
                  <strong>GRANT OF RIGHTS</strong>
                  <ol className="olTypea">
                    <li>
                      Exclusive, irrevocable, royalty-free, assignable and
                      sub-licensable license and right (but not the obligation)
                      along with all intellectual property rights appurtenant
                      thereto (including without limitation all copyright,
                      trademark, and performing rights that are necessary or
                      desirable to exhibit, display and broadcast the content
                      that is owned by the User)
                    </li>
                    <li>
                      Use and to make available the Content, via the Modes,
                      using the Platform, in the following manner:
                    </li>
                    <li>
                      To reproduce, compile, host, store, cache, archive the
                      Content, on the Platform&apos;s servers for exercising the
                      rights granted under this Agreement;
                    </li>
                    <li>
                      To encrypt and encode the Content with digital rights
                      management mechanisms;
                    </li>
                    <li>
                      Allow seven (7) days catch-up content of the Channel(s)
                      and/or Clips to the Subscriber using the catch-up
                      functionality of the Platform including interactive
                      streaming like stop, start, pause, fast-forward, jump or
                      rewind the Channels and/or Clips on their Device(s);
                    </li>
                    <li>
                      Allow Subscribers to enable recording/downloading any
                      content of the Channel and/or Clips only through mechanism
                      provided on the Platform for subsequent viewing.
                    </li>
                    <li>
                      permit caching of Channels and/or Clips for delivery
                      through CDN mode;
                    </li>
                    <li>
                      transmit Clips and/or Channel including the catch-up
                      content on subscription, non-subscription and/or
                      advertisement supported basis;
                    </li>
                    <li>
                      to insert or replace the existing advertisements
                      transmitted in the Channel and/or catch-up content of the
                      Channel and/or Clips with any other advertisements and in
                      this regard the Network shall provide advertisement
                      markers, cue tones, SCTE markers, etc., to enable LYK to
                      place the advertisements in the Channel;
                    </li>
                    <li>
                      convert the format of the Channel and/or Clips to any
                      other format for exercising the rights granted under this
                      Agreement including a right to down-conversion and
                      up-conversion of the Channel and/or Clips; and
                    </li>
                    <li>
                      do all such incidental and ancillary acts that are
                      required for exercising the rights granted herein,
                      including granting a sub-license to a third party for the
                      limited purpose of exercising any of the above-mentioned
                      rights.
                    </li>
                    <li>
                      advertise, promote, publicize, market and sell
                      subscriptions of the Platform to prospective Users;
                    </li>
                    <li>
                      utilize any portion of the Content for purposes of
                      advertising, marketing and promoting the Service as
                      distributed by LYK;
                    </li>
                    <li>
                      up-convert the Signal from standard definition to high
                      definition;
                    </li>
                  </ol>
                  <p>
                    <em>
                      It shall be the sole responsibility of the User to ensure
                      that the content being uploaded through Live TV is as per
                      the specifications of the Platform and that it does not
                      fall under any of the content that is violative under the
                      guidelines set forth by the Platform.
                    </em>
                  </p>
                </li>

                <li>
                  <strong>CONTENT OF THE SERVICE</strong>
                  <ol className="olTypeA">
                    <li>
                      <strong>A. Content Requirements; Prohibitions.</strong>{' '}
                      Throughout the Term, Network shall ensure that the Service
                      complies in all material respects, at all times, with the
                      Content Description (which Content Description is
                      essential to this Agreement), and shall not contain
                      Content other than as so described in the Content
                      Description unless approved by LYK after sending a mail to
                      the LYK Team at{' '}
                      <a href="mailto:legal@lykstage.com">legal@lykstage.com</a>
                      . Network agrees that the Service (including any
                      advertisements contained therein unless such
                      advertisements were produced and inserted by LYK) may not,
                      under any circumstance, contain:
                      <ol className="olTypei">
                        <li>
                          advertisements for, or otherwise mention, any
                          distributor of programming services that are not owned
                          and/or operated by LYK and/or its Affiliates or any
                          other programming services that are not carried by
                          LYK;
                        </li>
                        <li>
                          programming that, under United States law, rule or
                          regulation is (or in the sole discretion of LYK is
                          likely to be deemed) defamatory, libelous, slanderous
                          or obscene;
                        </li>
                        <li>
                          programming that violates or infringes (or in the
                          reasonable judgment of LYK is likely to violate or
                          infringe) any copyright, trademark, right of privacy
                          or literary or dramatic right of any person or entity;
                        </li>
                        <li>
                          direct on-air sales programming (infomercials); or
                        </li>
                        <li>
                          promotion or marketing of &quot;800&quot;,
                          &quot;888&quot;, &quot;900&quot;, or &quot;976&quot;
                          telephone services, or other similar services that
                          bill a caller for placing or confirming the call
                          (other than for the telephone company&apos;s cost of
                          the call).
                        </li>
                      </ol>
                    </li>
                    <li>
                      <strong>B. Violative Content.</strong> If LYK, in its sole
                      discretion, determines that:
                      <ol className="olTypei">
                        <li>
                          the Service includes or included programming that is
                          prohibited under Section 3.1;
                        </li>
                        <li>
                          Network has granted or attempted to grant any
                          exclusive rights granted to to another person or
                          entity; or
                        </li>
                        <li>
                          the programming of the Content does not comply with
                          the Content Description set forth in Part B, then LYK
                          may, in addition to any other rights it may have under
                          this Agreement, at law or in equity, elect to: (a)
                          retain 100% of the License Fees payable to the Network
                          till date as liquidated damages and not as a penalty,
                          Network recognizing that LYK would be irreparably
                          harmed as a result of such programming and that its
                          damages would be difficult to ascertain; or (b)
                          pre-empt any portion of the Service that is prohibited
                          by Section A and replace such pre-empted programming
                          with programming it deems non-violative; or (c)
                          immediately suspend or discontinue its performance
                          hereunder including, without limitation, suspending or
                          discontinuing carriage of the Service upon written
                          notice to Network. In the event LYK elects to suspend
                          carriage of the Service, this Agreement shall remain
                          in full force and effect with respect to the rights
                          granted to LYK and only the duties and obligations of
                          LYK shall be suspended until such time as LYK is
                          assured that all the Content available is
                          non-violative in accordance with the provisions of
                          this Section B.
                        </li>
                      </ol>
                    </li>
                    <li>
                      <strong>C. Document Delivery.</strong> Upon LYK&apos;s
                      request, Network will deliver, or cause to be delivered,
                      to LYK certified copies of all documents (together with
                      certified translations of documents not in the English
                      language) deemed by LYK to be necessary to fully and
                      completely evidence Network&apos;s acquisition of all
                      rights necessary to effect Network&apos;s grant of rights
                      to LYK hereunder. Network will promptly notify LYK in
                      writing if Network has any knowledge of any suit,
                      complaint or claim alleging that the Service or any of its
                      constituent elements infringes or otherwise violate(s) any
                      trademark, copyright or other intellectual property right.
                    </li>
                    <li>
                      <strong>D. Second Service.</strong> Network agrees that it
                      will not use the Service to nest or incubate another
                      programming service within the Service (a &quot;Second
                      Service&quot;), nor will it &apos;clone&apos; the Service
                      into a Second Service by duplicating programming from the
                      Service on to any such Second Service and/or by removing
                      programming from the Service and distributing it on such
                      Second Service.
                    </li>
                  </ol>
                </li>

                <li>
                  <strong>REPRESENTATIONS AND WARRANTIES</strong>
                  <ol className="olTypei">
                    <li>
                      <strong>By Network.</strong> Without limiting and in
                      addition to Network&apos;s other representations and
                      warranties set forth in these Conditions, Network
                      represents and warrants to LYK that:
                      <ol className="olTypeA">
                        <li>
                          A.The Network presently owns and will continue to own
                          at all times during the Term all rights necessary to
                          grant LYK and its Affiliates the rights contracted for
                          by LYK under this Agreement, including without
                          limitation all rights necessary to permit LYK and its
                          Affiliates to distribute and broadcast all programming
                          content included within the Service in the Territory
                          in accordance with the grant of rights set forth in
                          Section 2 above;
                        </li>
                        <li>
                          B.The Network presently has and will continue to have
                          at all times during the Term all rights necessary to
                          grant LYK the right to use Network&apos;s trademarks,
                          service marks, logos and related trade usage as
                          permitted hereunder;
                        </li>
                        <li>
                          C.The Network and the Service presently are and will
                          remain, at all times during the Term, in full
                          compliance with all applicable laws, codes, rules and
                          regulations, including without limitation all such
                          statutes, laws, rules, regulations and orders
                          enforced, administered, promulgated or pronounced in
                          the United States and in the country or countries in
                          which the content for the Service originated;
                        </li>
                        <li>
                          D.No programming included as part of the Service will
                          be defamatory, libelous, slanderous or obscene nor
                          will it contain any material that violates or
                          infringes any copyright, right of privacy or literary
                          or dramatic right of any person or entity;
                        </li>
                        <li>
                          E.No advertising sold or inserted by Network in the
                          Service shall be for, of or concerning any
                          multi-channel video programming service provider or
                          distributor other than LYK;
                        </li>
                        <li>
                          F.The Network will license and pay for as and when due
                          any and all copyright, royalty or other performance
                          rights payments through to the viewer, including
                          without limitation payments to ASCAP, BMI, SESAC and
                          any other applicable music performance society or
                          other applicable entity with respect to all
                          programming included as part of the Service;
                        </li>
                        <li>
                          G.The Network will not directly or indirectly grant
                          (or allow any third party to grant) any other
                          programming distributor any rights whatsoever with
                          respect to the Service (or any individual programs
                          contained therein) within the Territory or directly or
                          indirectly assist any third party with the acquisition
                          of any rights to distribute Network Foreign Language
                          programming services;
                        </li>
                        <li>
                          H.The Network is under no contractual or other legal
                          obligation that shall in any way interfere with its
                          full, prompt and complete performance hereunder;
                        </li>
                        <li>
                          I.No third party has claimed, or to the best knowledge
                          of Network has, any rights that would be inconsistent
                          with the rights granted to LYK hereunder;
                        </li>
                      </ol>
                    </li>
                    <li>
                      <strong>Disclaimer of Warranty.</strong> LYK MAKES NO
                      REPRESENTATION OR WARRANTY OF ANY KIND WHATSOEVER (EITHER
                      EXPRESS, IMPLIED) AND HEREBY EXPRESSLY DISCLAIMS ALL
                      LIABILITY WITH RESPECT TO ANY TRANSMISSION OF THE CONTENT
                      (INCLUDING WITHOUT LIMITATION TRANSMISSION BY ANY OF
                      LYK&apos;S AFFILIATES). IF AND TO THE EXTENT THERE IS ANY
                      SERVER OR COMMUNICATION FAILURE FOR ANY REASON WHATSOEVER
                      WITH RESPECT TO SUCH TRANSMISSION, NETWORK AGREES THAT
                      LYK&apos;S LIABILITY, TO THE EXTENT SUCH LIABILITY IS
                      FOUND NOTWITHSTANDING THE FOREGOING DISCLAIMER, SHALL BE
                      LIMITED TO ANY ACTUAL MONEY DAMAGES LYK RECEIVES FROM ANY
                      THIRD PARTY SERVICE PROVIDER SPECIFICALLY ATTRIBUTABLE TO
                      THE PROGRAMMING SERVICE BEING TRANSMITTED.
                    </li>
                  </ol>
                </li>

                <li>
                  <strong>WITH RESPECT TO LYKSTAGE TERMS OF SERVICE</strong>
                  <p>
                    These LIVE TV Terms of Service shall be read alongside the
                    LYKSTAGE Terms of Service and the LYKSTAGE PRIVACY POLICY.
                  </p>
                  <p>
                    These LIVE TV Terms of Service are in no way an exhaustive
                    list of clauses and covenants binding the User nor are they
                    an Entire Agreement and the User availing the Live TV
                    content shall be bound by the LYKSTAGE Terms of Service as a
                    whole.
                  </p>
                </li>
              </ol>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.2.
                <span> </span>
              </span>
              <span>Uploading Content</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.2.1.<span> </span>
              </span>
              <span>
                For the purpose of uploading Content on the Platform, the User
                shall have a User Account on the Platform. If the User chooses
                to upload Content, the User shall not post on the Platform any
                Content piece that does not comply with this Agreement or any of
                the Applicable Laws.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.2.2.<span> </span>
              </span>
              <span>
                For example, the content the User submits shall not include
                third-party intellectual property (such as copyrighted material)
                unless the User have permission from that party or are otherwise
                legally entitled to do so.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.2.3.<span> </span>
              </span>
              <span>
                The Company may use automated systems that analyze the Content
                to help detect infringement and abuse, such as spam, malware,
                and illegal Content. If the Content is clear, then it may get
                uploaded on the Platform. The User may offer their content for
                free or may charge a premium feet hat the other User shall pay
                in order to have an access to it.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.3.
                <span> </span>
              </span>
              <span>Rights granted to User</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.3.1.<span> </span>
              </span>
              <span>
                The User retains all of the ownership rights in the Content. In short, what belongs to the User stays with the User. However, by uploading Content and using the Services of the Platform, the User grants certain rights to the Company and to other users of the Service, as described below.
              </span>
              <ol className="olTypei">
                <li>
                  <strong>License to the Company:</strong> By uploading Content on the Platform, the User grants to the Company a worldwide, non-exclusive, royalty-free, transferable, sub-licensable license to host, store, reproduce, distribute, display, perform, and otherwise use that Content for the purpose of operating, promoting, and improving the Service, including across the Platform and all of its supported devices and distribution channels (such as mobile, web, and Connected TV, and any current or future integrations).
                </li>
                <li>
                  <strong>Operational Use for Recommendations and Discovery: </strong> The license granted to the Company in this Clause includes the right to process the User’s Content, together with its associated metadata and engagement signals, to operate, power, and improve the Platform’s content discovery, ranking, search, and recommendation systems. This operational processing enables the User’s Content to be surfaced to relevant audiences and enables the Platform to recommend relevant Content to viewers. The User acknowledges that this operational processing is a core and necessary part of providing the Service, and that it benefits creators and viewers alike by improving discoverability and relevance across the Platform.
                </li>
                <li>
                  <strong>License to other Users:</strong> The User also grants other users of the Service a worldwide, non-exclusive, royalty-free license to access the User’s Content through the Service and to use that Content (including reproducing, distributing, displaying, and performing it) only as enabled by a feature of the Service.
                </li>
                <li>
                  <strong>AI Model Training Governed Separately:</strong> The use of the User’s Content to train, fine-tune, develop, or enhance the Lykstage AI Model or any third-party artificial-intelligence model — beyond the operational discovery and recommendation processing described in sub-clause (2) above — is not granted by this Clause. Any such AI model training is governed separately by Clause 7.5.5 and requires the User’s distinct, opt-in consent. For the avoidance of doubt, the operational processing described in sub-clause (2) does not, by itself, grant the Company any right to use the Content for general AI model training.
                </li>
                <li>
                  The User’s ownership shall not extend to any content, insights, or derivative works that are solely generated by the Platform or the Lykstage AI Model using the uploaded Content, and such Platform-generated or AI-generated outputs shall solely and exclusively belong to the Company.
                </li>
              </ol>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.4.
                <span> </span>
              </span>
              <span>Duration of License</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.4.1.<span> </span>
              </span>
              <span>
                The licenses granted by continue until the Content is removed as
                described below. Once removed, the licenses will terminate,
                except where the operation of the Service, use of the Content
                permitted before the removal, or the law requires otherwise.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.4.2.<span> </span>
              </span>
              <span>
                For example, removal of Content by the User does not require the
                Platform to (a) recall Content that is being used by other users
                within any limited offline viewing functionality of the Service;
                or (b) delete copies the Company reasonably needs to keep for
                legal purposes.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.5.
                <span> </span>
              </span>
              <span>Statutory Rights of the User</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.5.1.<span> </span>
              </span>
              <span>
                {' '}
                Edit or Delete Content: The User shall be given an option to
                edit the Content uploaded on the Platform. The editing option
                may be limited to editing or changing the name of the Content,
                price charged by the User/Creator, description of the Content
                and thumbnails. The User may delete the Content from the
                Platform at any time. The User shall also have the option to
                make a copy of the Content before removing it. The User shall
                remove the Content if the User no longer have the rights
                required by these terms.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.5.2.<span> </span>
              </span>
              <span>
                Revenue Generation: The User shall have the right to the revenue
                generated by the Content uploaded by them except in the
                instances they are found to be in violation of these Terms of
                Service.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.5.3.<span> </span>
              </span>
              <span>
                Seek Information about the data collected: The User may seek
                from the Platform as to the data collected and possessed till
                that date upon serving a request to the same through an E-Mail:
                info@lykstage.com. The Company shall first review such request
                and upon the Company&apos;s satisfaction for the request to be
                genuine, may provide a list of information to such User.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.5.4.<span> </span>
              </span>
              <span>
                {' '}
                Deletion of Data upon intimation: The User may request the
                Platform to delete all the data collected and possessed till
                that date upon serving a request to the same through an
                E-Mail:info@lykstage.comThe Company, in such situation shall
                comply with such a request and the User may also seek the copy
                of said data that is to be deleted.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.5.5.<span> </span>
              </span>
              <span>
                <span className="msoIns">
                  <ins>
                    {' '}
                    Providing or withdrawing consent for the training of the AI model:
                  </ins>
                </span>
              </span>
              <p
                style={{
                marginLeft: '-0.1in',
                textIndent: '0',
              }}
              >
                Separate from the operational discovery and recommendation processing described in Clause 7.3.1(2) — which forms part of providing the Service — the training, fine-tuning, or development of the Lykstage AI Model or any third-party AI model using the User’s Content requires the User’s explicit, opt-in consent, as set out below.
              </p>
              <ol className="olTypei">
                <li>
                  The Platform shall, by default, not process the Content or other data of the User to train the Lykstage AI Model or the AI models of third parties associated with the Company for general AI model development without the consent of the User.
                </li>
                <li>
                  The User may provide their consent to allow their Content and its associated metadata to be used for AI Model training, for the purposes mentioned within these Terms, by going to their Profile settings and enabling the option that states <b>“Allow my content to be used for AI training purposes.”</b>
                </li>
                <li>
                  The Company represents and warrants that such access shall be limited to the Content and its associated metadata (such as title, comments, and engagement) and shall not, in any manner, extend to the personal information of the User.
                </li>
                <li>
                  The User may, at any time, withdraw their consent for their Content to be used for the training of the AI Model through the same means, by going to their Profile settings. The User acknowledges that withdrawal of consent shall operate prospectively only: it shall not delete or reverse any training already performed using the Content before the withdrawal, nor affect the consent of other users who have provided their own Content for AI training, nor affect any instance in which the User’s comment on another user’s Content was used to train the AI Model.
                </li>
                <li>
                  Please note that providing consent to allow the Content to be used for training the Lykstage AI Model or the AI models of third parties shall not result in any additional rewards or monetization for the User, and the User understands that such consent is provided solely on the full and free consent of the User.
                </li>
              </ol>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '1.35in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                <span className="msoIns">
                  <ins></ins>
                </span>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.5.6.<span> </span>
              </span>
              <span>Removal/Deletion of Content by the Platform/Company:</span>
              <span> </span>
              <span>
                If the Company reasonably believe that any Content is in breach
                of this Agreement or may cause harm to the Platform, our Users,
                or third parties, the Company may suomoto remove or take down
                some or all of such Content. The Company shall notify the
                respective User of the reason for the action unless the Company
                reasonably believe that to do so for some particular reasons:
              </span>
              <ol className="olTypei">
                <li>
                  may violate the law or the direction of a legal enforcement
                  authority, or would otherwise risk legal liability for the
                  Platform or Company&apos;s affiliates;
                </li>
                <li>
                  may compromise an investigation or the integrity or operation
                  of the Service;
                </li>
                <li>
                  may cause harm to any User, any third party, the Platform, or
                  the Company or any affiliates.
                </li>
                <li>
                  reported by any User/viewer for any reasons stated in the
                  option of “Report Video”.
                </li>
                <li>
                  Upon any request for deletion received from a User, the
                  Platform may review that Content and solely based upon their
                  discretion, deletion of such Content shall take place.
                </li>
              </ol>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.5.7.<span> </span>
              </span>
              <span>
                {' '}
                Permissions and Restrictions: The User may access and use the
                Services as made available, as long as the User complies with
                these Terms of Service and the Applicable Laws. The other
                Users/viewers may view or listen to Content for their personal,
                non-commercial use.
              </span>
              <span> </span>
              <span>
                The following restrictions apply to using the Services. The User
                is not allowed to:
              </span>
              <ol className="olTypei">
                <li>
                  Access, reproduce, download, distribute, transmit, broadcast,
                  display, sell, license, alter, modify, or otherwise use any
                  part of the Service or any Content except the following.
                  <ol className="olTypea">
                    <li>as specifically permitted by the Platform;</li>
                    <li>
                      with prior written permission from the Platform and, if
                      applicable, the respective right holders;
                    </li>
                    <li>as permitted by Applicable Laws.</li>
                  </ol>
                </li>
                <li>
                  Circumvent, disable, fraudulently engage, or otherwise
                  interfere with the Service (or attempt to do any of these
                  things), including security-related features or features that:
                  <ol className="olTypea">
                    <li>
                      prevent or restrict the copying or other use of Content;
                    </li>
                    <li>limit the use of Service or Content.</li>
                  </ol>
                </li>
                <li>
                  Access the Service using any automated means (such as robots,
                  AI Models, botnets, or scrapers) except:
                  <ol className="olTypea">
                    <li>
                      in the case of public search engines, in accordance with
                      the Platform&apos;s robots.txt file;
                    </li>
                    <li>with the Platform&apos;s prior written permission;</li>
                    <li>as permitted by Applicable Laws.</li>
                  </ol>
                  <p className='olTypea mb-2'><b>*</b> This restriction is further detailed in Clause 7.7.</p>
                </li>
                <li>
                  Collect or use any information that might identify a person
                  (for example, harvesting usernames), unless permitted by that
                  person.
                </li>
                <li>
                  Use the Service to distribute unsolicited promotional or
                  commercial Content or other unwanted or mass solicitations
                  (spam).
                </li>
                <li>
                  Cause or encourage any inaccurate measurements of genuine user
                  engagement with the Service, including by paying people or
                  providing them with incentives to increase a video&apos;s
                  views, likes, or dislikes, or to increase a channel&apos;s
                  subscribers, or otherwise manipulate metrics.
                </li>
                <li>
                  Misuse any reporting, flagging, complaint, dispute, or appeals
                  process, including by making groundless, vexatious, or
                  frivolous submissions.
                </li>
                <li>
                  Use the Service to:
                  <ol className="olTypea">
                    <li>
                      view or listen to Content other than for personal,
                      non-commercial use (for example, you may not publicly
                      screen videos or stream music from the Service).
                    </li>
                    <li>
                      sell any advertising, sponsorships, or promotions placed
                      on, around, or within the Service or Content, other than
                      those allowed in the advertising policies (such as
                      compliant product placements);
                    </li>
                    <li>
                      sell advertising, sponsorships, or promotions on any page
                      of any Website or application that only contains Content
                      from the Service or where Content from the Service is the
                      primary basis for such sales (for example, selling ads on
                      a webpage where LYKSTAGE videos are the only Content of
                      value).
                    </li>
                  </ol>
                </li>
              </ol>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '1.85in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.5.8.<span> </span>
              </span>
              <span>Modification:</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                The Platform is constantly changing and improving its Service.
                The Platform reserves the right to change, alter, modify, or
                discontinue a Service, product, or feature as and when the
                Company deems fit. Changes to this Agreement are made as
                described in Clause 32, including at least 30 days' notice
                of material changes through an in-app notice and by email.
                The Company shall also post the modified version on this page.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.6.
                <span> </span>
              </span>
              <span><strong>Connected TV Distribution</strong></span><br/>
              <span>
                LYKSTAGE may distribute creator content on various Connected TV or third-party partner platforms. By enabling Connected TV distribution, the creator grants LYKSTAGE permission to publish, display, and monetize the creator’s content across any current or future Connected TV integrations.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.6.1.
                <span> </span>
              </span>
              <span>
                <strong>Revenue-Sharing and Earnings Variability</strong>
              </span>
              <ol className="olTypei">
                <li>
                  Certain Connected TV partners may operate under mandatory revenue-sharing agreements that can affect LYKSTAGE’s advertising revenue. As a result, creator earnings for views or monetization events that occur on Connected TV platforms may differ from earnings generated on LYKSTAGE’s mobile, tablet, or web applications.
                </li>
                <li>
                  LYKSTAGE does not guarantee uniform earnings across all distribution channels, and creators acknowledge that Connected TV distribution may result in reduced or varied earnings due to partner-level monetization rules.
                </li>
              </ol>
            </p>
            
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.6.2.
                <span> </span>
              </span>
              <span>
                <strong>Creator Consent</strong>
              </span>
              <ol className="olTypei">
                <li>
                By enabling Connected TV distribution at the time of upload, the creator explicitly acknowledges and agrees that:
                  <ol className="olTypea">
                    <li>LYKSTAGE may distribute the content across any eligible Connected TV platforms.</li>
                    <li>
                      Earnings from Connected TV views may vary due to revenue-sharing arrangements with third-party partners.
                    </li>
                    <li>LYKSTAGE bears no responsibility for differences in monetization policies applied by such third-party platforms.</li>
                  </ol>
                </li>
                <li>
                Creators must provide affirmative consent during the upload process for Connected TV distribution to be enabled.
                </li>
              </ol>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.7.
                <span> </span>
              </span>
              <span><strong>Prohibition on Unauthorized Automated Access, Scraping, and Direct CDN Access</strong></span><br/>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.7.1.
                <span> </span>
              </span>
              <span>
                <strong>Definitions.</strong> For the purposes of this Clause, <strong>"Automated System"</strong> means any bot, crawler, spider, scraper, headless browser, script, AI agent, data-ingestion or data-mining tool, or other automated or programmatic means of access, whether operated by an individual, a company, or an artificial-intelligence system. <strong>"Content Delivery Network"</strong> or <strong>"CDN"</strong> means any server, storage system, edge node, origin infrastructure, signed or unsigned media URL, or delivery endpoint used by the Platform to host, cache, stream, or deliver Content, including video files and their associated media segments, manifests, thumbnails, and metadata.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.7.2.
                <span> </span>
              </span>
              <span>
                <strong>General Prohibition.</strong> Except with the Platform's prior express written permission, no User, person, or entity — including, without limitation, third-party operators of search, indexing, advertising, social-media, or artificial-intelligence services (such as crawlers operated by Meta or any comparable operator) — may access, read, download, copy, cache, store, scrape, harvest, index, stream, re-transmit, or otherwise process any Content, video file, or media asset:
              </span>
              <br/>  <span>(a) through direct access to the Platform's CDN, origin servers, storage URLs, or delivery endpoints, in a manner that bypasses the Platform's user interface, application layer, access controls, or authentication mechanisms; or</span>
              <br/>  <span>(b) by means of any Automated System, regardless of whether such access occurs through the Platform interface or directly via the CDN.</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.7.3.
                <span> </span>
              </span>
              <span>
                <strong>No Use for AI or Dataset Purposes.</strong> Without limiting Clause 7.7.2, no Content accessed via the Platform or its CDN may be collected, reproduced, or used to develop, train, fine-tune, evaluate, or improve any machine-learning or artificial-intelligence model, or to build any dataset, corpus, archive, or competing service, except with the Platform's prior express written permission.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.7.4.
                <span> </span>
              </span>
              <span>
                <strong>Limited Exception for Search Engines.</strong> Clause 7.7.2(b) does not apply to operators of bona fide public search engines, but only to the extent that they access the Platform in strict accordance with the Platform's robots.txt file and any other machine-readable access directives published by the Platform. The Platform may withdraw, restrict, or modify this permission at any time, including by updating its robots.txt file. This exception does not authorize direct CDN access under Clause 7.7.2(a) or any use described in Clause 7.7.3.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.7.5.
                <span> </span>
              </span>
              <span>
                <strong>Technical Measures and Enforcement.</strong> The Platform employs, and reserves the right to employ, technical measures — including but not limited to rate limiting, token-based authentication, signed URLs, IP blocking, and bot-detection systems — to restrict unauthorized access. Any attempt to circumvent, disable, probe, or interfere with such measures constitutes a material breach of these Terms. The Platform reserves the right to block access, suspend or terminate accounts, and pursue all remedies available at law or in equity, including injunctive relief, against any party that violates this Clause.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                7.7.6.
                <span> </span>
              </span>
              <span>
                <strong>No Implied License.</strong> Nothing in these Terms, and no act of making Content publicly viewable through the Platform, grants any person or Automated System any license or right to access Content other than through the Platform's intended user-facing interface in accordance with these Terms.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  8.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Account Subscription</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                8.1.
                <span> </span>
              </span>
              <span>
                The User shall have an option to subscribe to other Users&apos;
                account whereupon, the User shall receive regular updates about
                any activity of those Users on the Platform. The User shall
                receive updates in the notification section.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  9.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Reward System</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.1.
                <span> </span>
              </span>
              <span>Reward for Signing Up/ Valuation of Lyk Coins:</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                For signing up on the Platform, the User shall receive Lyk Coins
                as follows per their jurisdiction.
              </span>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.2. The valuation of LYK Coins shall be in Dollars, and it will
                be a fixed global valuation, i.e50 LYK Coins = $ 1/-
                <span> </span>
              </span>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.3.
                <span> </span>
              </span>
              <span>Reward for Uploading Content</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.3.1.<span> </span>
              </span>
              <span>
                The mere uploading of Content on the Platform shall not entitle
                the User to any earnings or monetary compensation. The User
                shall be eligible to receive revenue only in the event that the
                uploaded content is (i) approved for monetization by the
                Platform, and (ii) receives substantial viewer engagement and
                traction, as determined at the sole discretion of the Platform
                in accordance with its internal guidelines and algorithms. The
                decision of the Platform in this regard shall be final and
                binding.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.3.2.<span> </span>
              </span>
              <span>
                Depending on the views received by the Content so uploaded, and
                the same shall reflect in the &apos;Earnings&apos; section of
                the Platform.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.3.3.<span> </span>
              </span>
              <span>
                Such LYK Coins shall be redeemable once minimum of one thousand
                three hundred (1300) LYK Coins get collected for the
                jurisdiction of United States of America. If the User is not a
                resident of the United States of America, the User may view the
                minimum number of Lyk Coins they must collect before redemption
                through the Earnings page.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.3.4.<span> </span>
              </span>
              <span>
                There shall be necessary obligations, including but not limited
                to e-KYC, which the User shall perform in order to redeem the
                amount. If the redemption values are such where the Company have
                to necessarily deduct the necessary taxes, then it shall be
                performed without any discrepancy and objection from the
                User&apos;s side. The above-mentioned denomination and values
                may change solely upon the discretion of the Platform.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.3.5.<span> </span>
              </span>
              <span>
                It is to be noted that the Users shall not receive any rewards
                for uploading Live Content on the
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.4.
                <span> </span>
              </span>
              <span>Reward for viewing Content on the Platform:</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.4.1.<span> </span>
              </span>
              <span>
                The Users shall be rewarded as per the Monetized Watch time
                Units which shall mean and include the specific measure of watch
                time on the Platform that qualifies for monetization. In such
                Monetized Watch Time Unit, the user shall be displayed with an
                advertisement on the content monetized on the Platform while the
                User is logged in on the Platform. The User shall not accrue any
                rewards for watching content that has not been monetized by
                advertisements, if the User skips the advertisements or if the
                User is not logged into their User Account. The user must
                complete the entire measure of the Monetized Watch Time Unit to
                be eligible to accrue Earnings. For reference, every thirty (30)
                seconds of uninterrupted viewing constitutes a single Monetized
                Watch Time Unit.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.4.2.<span> </span>
              </span>
              <span>
                The Platform shall tally up the Monetized Watch Time Units every
                twenty-four (24) hours to finalize the Lyk Coins earned by the
                User. The User may view the same through the “Earnings Section”
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.4.3.<span> </span>
              </span>
              <span>
                The Users who are watching the Content that has been monetized
                on the Platform, shall be rewarded in LYK Coins. The number of
                Lyk Coins awarded to the User shall vary depending on the
                jurisdiction of the User and the frequency and rate of the
                advertisements. The User may check the number of Lyk Coins they
                are eligible to receive for their watchtime through the Earnings
                Section which shall contain all the information in relation to
                the jurisdictional valuation and eligibility of the Lyk Coins
                received by the User. It shall be noted that if the same viewer
                again consumes the same monetized Content, then the User shall
                not be eligible for the reward. There being a unique watch time
                consumed is a compulsion for claiming the reward. In order to
                redeem the LYK Coins collected, the User shall ensure minimum of
                LYK Coins mentioned above being reflected in the
                &apos;Earnings&apos; Section. The values mentioned here may
                change based upon the sole discretion of the Platform.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.4.4.<span> </span>
              </span>
              <span>
                The User must note that to be eligible for rewards for viewing
                content, they must view content within the time frame of 00:00
                hours to 24:00 hours and will only be able to redeem their
                rewards for content viewed to the maximum of six (6) hours in a
                day. These six hours shall not be carried over to the next day
                and the User shall only be able to avail the reward for the
                duration viewed within the said six
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.5.
                <span> </span>
              </span>
              <span>Reward for making References</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.5.1.<span> </span>
              </span>
              <span>
                In addition, the User shall be rewarded a total of Fifty (50)
                LYK Coins when the User shares referral link and code pertaining
                to the Platform with a potential User and such User actually
                signs up on the Platform. The credit of such LYK Coins shall
                reflect in the Earnings and Reward only after the referred User
                completes the profile verification of their Account after the
                sign-up process. In order to know more about the referral
                programme guidelines, the User may go through the &apos;Referral
                Programme Guidelines&apos; on the Platform.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.6.
                <span> </span>
              </span>
              <span>Reward to be paid in Advance</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.6.1.<span> </span>
              </span>
              <span>
                content, as specified by LYKSTAGE may be eligible for receiving
                LYK coins in Advance. The advance amount will be deducted from
                the creator&apos;s future total earnings on the LYKSTAGE until
                it is fully adjusted.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.6.2.<span> </span>
              </span>
              <span>
                The Creators receiving LYK coins in advance will not be able to
                delete the videos for which they received advance LYK coins or
                close their accounts until the advance amount is fully
                recovered.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.6.3.<span> </span>
              </span>
              <span>
                The said Creators will only be eligible for redemption after the
                full advance amount is adjusted.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.6.4.<span> </span>
              </span>
              <span>
                The eligibility of the creators for receiving the reward in
                Advance shall be at the sole discretion of LYKSTAGE and the same
                may be revised without a prior notice.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.7.
                <span> </span>
              </span>
              <span>Viewing the Rewards</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.7.1.<span> </span>
              </span>
              <span>
                The Users may view their rewards through the Earnings Section on
                the Earnings Dashboard.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.7.2.<span> </span>
              </span>
              <span>
                The number of Lyk Coins earned by the User are updated every 24
                hours at 12:00 am GMT. The number of Lyk Coins displayed are
                according to the amount of time the User has viewed the
                monetized Content as per the conditions placed in these Terms on
                a monthly basis.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.7.3.<span> </span>
              </span>
              <span>
                The Earnings Dashboard also displays the Lyk Coins acquired by
                the User from the previous months.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.7.4.<span> </span>
              </span>
              <span>
                On the first day of each month, the Platform shall review all
                earning and confirm the total Lyk Coinsearned by the User that
                month, making the balance redeemable subject to the condition
                that the minimum number of coins have been attained.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.
                <span> </span>
              </span>
              <span>To Be Noted by the User</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.1.<span> </span>
              </span>
              <span>
                The Users must note and understand that the rewards earned by
                them shall be subject to the jurisdiction that they reside in.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.2.<span> </span>
              </span>
              <span>
                The Users must note that in case they view a video with
                advertisements, they shall have to watch the entire
                advertisement to be eligible for the rewards.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.3.<span> </span>
              </span>
              <span>
                The User must note that they shall not receive any Rewards for
                content that has not been monetized by the means of
                advertisements.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.4.<span> </span>
              </span>
              <span>
                Regardless of the mode by which the Rewards are earned, the User
                can only redeem the LYK Coins earned through the “Earnings”
                section of the Platform.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.5.<span> </span>
              </span>
              <span>
                All the payment of the reward shall take place through the
                payment details given by the User while creating an account. The
                Company holds an undisputed liberty to amend the rules and
                policies of the reward system. The Platform shall authorize the
                Payment Processor for the redemption activity.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.6.<span> </span>
              </span>
              <span>
                It is to be noted that the User must be registered to be
                eligible to avail the rewards. If the User is not registered
                with the Platform, they will not be able to avail any rewards.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.7.<span> </span>
              </span>
              <span>
                It is to be noted that the eligibility for the monetization of
                the content uploaded, by any creator but by the broadcasting
                content creator and availing the rewards only extends to videos
                that have the duration of or greater than Three (3) Minutes. Any
                content below this threshold shall not be monetized by these
                Terms of Service. Meaning no User shall be eligible to avail
                rewards for the content under this threshold.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.8.<span> </span>
              </span>
              <span>
                It is to be noted that the eligibility for monetization of the
                content uploaded by Broadcasting content creator and availing
                the rewards only extends to videos that have the duration of or
                greater than Thirty (30) seconds. Any content below this
                threshold shall not be monetized by these Terms of Service.
                Meaning no User shall be eligible to avail rewards for the
                content under this threshold.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.9.<span> </span>
              </span>
              <span>
                The Company reserves the right to withhold the Rewards of any
                User that attempts to claim the rewards unfairly by the use of
                any unfair means, which shall include without limitation, spams,
                scams, impersonation, use of fake accounts made by the User
                themselves or the use of bot accounts.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                <span>
                  9.8.10.<span> </span>
                </span>
                <span>
                  It is to be noted by all Users that they have to provide their
                  accurate Tax Information during the encashment of the Rewards
                  and such information may be subject to verification by the
                  Platform or the Company.
                </span>
              </span>
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.11.<span> </span>
              </span>
              <span>
                The User must note that the Platform shall have the right to
                permanently hold back the rewards from the User if it is found
                that the User is fraudulently attempting to or is changing their
                jurisdiction using unauthorized VPN means and alike to
                manipulate their earnings/rewards.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.12.
                <span> </span>
              </span>
              <span>
                It is to be noted by the Creators that if their content is
                viewed in a country or a territory outside the jurisdiction in
                which the content was uploaded, their earnings by the means of
                rewards shall be subject to the following two factors:
              </span>
              <ol className="olTypei">
                <li>
                  If the Platform has enabled the facility of registration for
                  the User viewing the Content in the said territory, the
                  earnings of the Creators by means of the rewards shall be as
                  accordance to the jurisdiction in which the content has been
                  viewed in.
                </li>
                <li>
                  If the Platform has not enabled the facility of registration
                  for the user viewing the Content in the said territory, the
                  watch time of such a User shall not be considered and the
                  Creator shall not receive any earning by means of rewards.
                </li>
              </ol>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.13.
                <span> </span>
              </span>
              <span>
                The User must note that a one-time identity verification fee is deducted from the User's wallet balance at the time the User completes identity verification — not upon the first instance of cashing in Rewards. The applicable fee is based on the User's country of registration: India: 10 LYK Coins; United States, United Kingdom, Canada: 300 LYK Coins; UAE: 200 LYK Coins. LYK Coin amounts govern; US dollar equivalents shown on the Platform are for reference at the valuation in Clause 9.2. The User acknowledges that this deduction may reduce the User's balance below the minimum redemption threshold applicable to the User's country, in which case the User must again reach that threshold before the first redemption. Once the User's identity is verified, the User shall not be charged this fee again by the Platform.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.14.
                <span> </span>
              </span>
              <span>
                In addition to the one-time verification fee under Clause 9.8.13, each instance of cashing in or redeeming Rewards is subject to a separate redemption fee, applied to every redemption and independent of the verification fee: India: 5 LYK Coins per redemption; United States, United Kingdom, Canada, and UAE: 6% of the LYK Coins redeemed, rounded down to the nearest whole Coin. The Platform may revise the fees in Clauses 9.8.13 and 9.8.14 with prior notice published on the Platform's Earnings page and FAQs. Clause 9.8.15 (taxes, deductions, and conversion rates) continues to apply.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.15.
                <span> </span>
              </span>
              <span>
                The user must note that the final payout of the reward amount is
                subject to the ordinary taxations, deductions and conversion
                rates of their jurisdictions and the user themselves are
                responsible for fulfilling the compliance requirements on their
                end.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                9.8.16.
                <span> </span>
              </span>
              <span>
                The User wallet bearing the Lyk Coins of the user shall cycle on
                22nd day of each month, that is to say, the User&apos;s wallet
                statement shall close on 21st of every month, and the duration
                of cycle will start on 22nd of the previous month to the 21st of
                the ongoing month.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  10.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Reservation of Rights</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                The User acknowledge and agree that the Website and the Services
                are provided under license, and not sold, to them. Except to the
                extent necessary to access and use the Website and the Services,
                nothing in these Terms of Service grants any title or ownership
                interest in or to any copyrights, patents, trademarks, trade
                secrets, or other proprietary rights in or relating to the
                Website and the Services whether expressly, by implication,
                estoppel or otherwise. The Platform and its licensors and
                Service providers reserve and shall retain their entire right,
                title, and interest in and to the Platform and the Services,
                including all copyrights, trademarks, and other intellectual
                property rights therein or relating thereto, except as expressly
                granted to you in this agreement.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpLast"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  11.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Cookies</span>
              </b>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>11.1.</span>
              <span style={{ color: 'black' }}>
                Cookies are pieces of data/information regarding our Platform
                that is stored on the User&apos;s device through which the
                Platform is accessed.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>11.2.</span>
              <span style={{ color: 'black' }}>
                It stores information including but not limited to the username
                and password of the User, any preferences set by the User, the
                kind of advertisement preferred, etc.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>11.3.</span>
              <span style={{ color: 'black' }}>
                The basic objective of Cookies is to improve the experience of
                the User while using the Services provided on the Platform.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <b>
                <span style={{ color: 'black' }}>
                  11.4.
                  <span></span>
                </span>
              </b>
              <b>
                <span style={{ color: 'black' }}>
                  Permission of the User:-{' '}
                </span>
              </b>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>
                When a User visits the Platform for the first time, the User
                shall be given an option to allow the kind of cookies the User
                deems appropriate to be in force. Essential Cookies being an
                exception to this clause, the User shall be given an option to
                change the settings regarding cookies.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.5in',
                textAlign: 'justify',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>
                For further clarity, kindly visit our dedicated{' '}
                <a href="/privacypolicy">Privacy Policy</a>
              </span>
              <span className="MsoCommentReference">
                <span
                  style={{
                    lineHeight: '150%',
                    fontFamily: '"Times New Roman",serif',
                  }}
                ></span>
              </span>
              <span style={{ color: 'black' }}>. </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <b>
                <span style={{ color: 'black' }}>
                  11.5.
                  <span></span>
                </span>
              </b>
              <b>
                <span style={{ color: 'black' }}>
                  Tracking Technologies, and Advertising{' '}
                </span>
              </b>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>
                LYKSTAGE is an advertising-supported video platform. To operate the Service, present advertisements, measure the performance of advertisements, prevent fraud, and improve the Service, LYK Inc. and its affiliates use cookies, web beacons, pixels, mobile advertising identifiers, software development kits (SDKs), the IntersectionObserver browser API, local storage, server logs, and similar tracking technologies (together, "Tracking Technologies").
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>
                By creating an account, signing in, or otherwise using the Service, you acknowledge and agree to:
              </span>
            </p>
            <ul style={{ marginLeft: '.95in', lineHeight: '150%' }}>
              <li>
                the collection, use, sharing, and retention of information about you and your device as described in our Privacy Policy and Cookies Policy;
              </li>
              <li>
                the use of Tracking Technologies on the LYKSTAGE website and mobile applications;
              </li>
              <li>
                the receipt of advertising and the measurement of advertising performance on the Service.
              </li>
            </ul>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>
                This acknowledgement applies whether you access the Service as a registered user or as an unauthenticated guest. Where you access the Service as a guest, LYK Inc. assigns a pseudonymous cookie or device identifier to your session for the purposes described in the Privacy Policy.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>
                The Privacy Policy and the Cookies Policy are incorporated by reference into these Terms of Service. You may exercise your rights — including access, correction, deletion, objection, and (for California residents) the right to opt out of the sale or sharing of your personal information.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.5in',
                textAlign: 'justify',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <b>
                <span style={{ color: 'black' }}>
                  11.6.
                  <span></span>
                </span>
              </b>
              <b>
                <span style={{ color: 'black' }}>
                  Analytics, Session Replay, Attribution and Performance Tools{' '}
                </span>
              </b>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>
                The Platform uses the following service providers, which process information on the Company's behalf under contract: PostHog for product analytics and session replay; Singular for mobile attribution; Grafana for performance monitoring; and Firebase Crashlytics for crash reporting. Session replay masks text the User types, passwords, payment and bank details, and identity documents, which are not recorded. What each provider collects, and how long it is kept, is described in the Privacy Policy.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <b>
                <span style={{ color: 'black' }}>
                  11.7.
                  <span></span>
                </span>
              </b>
              <b>
                <span style={{ color: 'black' }}>
                  Advertising Identifiers and Tracking Permission{' '}
                </span>
              </b>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '30px',
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black'}}>
                On iOS, the LYKSTAGE application asks for the User's permission through Apple's App Tracking Transparency prompt before it accesses the device's advertising identifier (IDFA). If the User does not allow tracking, the Platform does not access the IDFA, and app-install attribution uses Apple's SKAdNetwork, which does not identify the User. On Android, the User may reset or delete the Google Advertising ID in the device settings.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpFirst"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  12.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Privacy Policy</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>12.1.</span>
              <span>
                The Company collects information pertaining to the Users either
                directly through them, or through cookies or through any other
                legitimate and known medium, and stores and records the same
                with utmost safety and security through advanced and upgraded
                encryption systems. The Company complies with all the applicable
                data privacy laws of the countries in which the Platform
                services is being provided.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>12.2.</span>
              <span>Privacy Control with the Users:-</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                The Users shall be able to enjoy a discretion pertaining to
                sharing of the information with the Company. Apart from the
                mandatory information asked for while creating a User Account or
                while the User seeks the advertisement services, or for any
                other purpose, the User shall have the option to disclose such
                data to the Company/Platform.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>12.3.</span>
              <span>Retaining Information:-</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                Post the deletion of the User Account or suspension of the same,
                the Company shall retain the information of the User for the
                maximum duration allowed by the applicable privacy law of the
                land from where the Platform service was availed.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>12.4.</span>
              <span>Compliance with Regulators:-</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                The Company may disclose the information of Users to the regulatory
                and law-enforcement authorities of the land in which the Platform
                operates where the law requires it, and shall disclose only the
                information the request requires. The Company shall protect information
                disclosed in this way as required by applicable law. The User remains
                responsible for the accuracy of the details the User provides to the Company,
                and for any consequences of impersonation or of providing inaccurate details.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>12.5.</span>
              <span>Notification and Device Permissions:-</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                The LYKSTAGE application asks for the User's permission before it
                accesses device features, including: storage, so that the User can
                upload videos; notifications, so that the Platform can send updates
                about new uploads and account activity; approximate location, as
                described in Clause 4.14; and, on iOS, tracking, through Apple's App
                Tracking Transparency prompt, as described in Clause 11.7. The User
                may change these permissions at any time in the device settings.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>12.6.</span>
              <span>Compliance with Privacy Laws</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                The Company affirms that all the clauses in this Agreement are
                compliant with the Applicable Privacy Laws of the land the User
                is residing in, an example without limitation is General Data
                Protection Regulation (For EU Countries);
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpLast"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoNormal"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span>
                For further clarity, kindly visit our dedicated{' '}
                <a href="/privacypolicy">Privacy Policy</a>.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpFirst"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>13.</b>
                <span> </span>
              </span>
              <span>
                <b>Intellectual Property Rights</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>13.1.</span>
              <span>IPR of the Company</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                13.1.1.
                <span> </span>
              </span>
              <span>
                All the Intellectual Property Rights (“IPR”) pertaining to but
                not limited to the Platform name, design, logo, html,interface,
                source code, backend architecture,software components, trade
                dress or any other kind of coding done for developing the
                Platform, advertisement about the Platform, etc shall remain
                solely in the name of the Company.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                13.1.2.
                <span> </span>
              </span>
              <span>
                The Company shall be at a liberty to license a part or whole of
                the IPR for a specific duration to a particular third-party
                entity for performance or fulfillment of a particular service
                offered by such third-party entity.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                13.1.3.
                <span> </span>
              </span>
              <span>
                If the User is falsely associates the IPR of the Platform or the
                Company either with the Content of the User or the User itself,
                the Company shall in response may suspend the User Account or
                may take any legal action as the Company deems fit.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>13.2.</span>
              <span>IPR of the User</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                13.2.1.
                <span> </span>
              </span>
              <span>
                Users retain ownership of the IPR in the content (including
                videos, audio, images, captions, and thumbnails) they upload to
                the Platform, provided they are the original rights holders or
                have obtained proper licenses. The Company does not claim
                ownership of such User content but is granted a license as
                outlined in this Terms
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                13.2.2.
                <span> </span>
              </span>
              <span>
                Any IPR breach or violation by another entity shall be dealt
                with personally by the owner of such IPR. The Company shall
                remain indemnified in this regard.\.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                13.2.3.
                <span> </span>
              </span>
              <span>
                Users are responsible for ensuring that any content they upload
                does not infringe upon the rights of others. The Company
                reserves the right to remove or restrict access to infringing
                content if it receives a valid takedown notice or becomes aware
                of an infringement.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>13.3.</span>
              <span>IPR of the Advertisements</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                The IPR of the Advertisements present or showcased on the
                Platform is neither a property of the Company nor does it has
                any relation to it. Any IPR breach or violation by another
                entity shall be dealt with personally by the owner of such IPR.
                The Company shall be held harmless in any such manner.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>14.</b>
                <span> </span>
              </span>
              <span>
                <b>Copyright Policy</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>14.1.</span>
              <span>Ownership of Content</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>14.1.1.</span>
              <span>
                The Platform recognizes and respects the intellectual property
                rights of all users. By submitting or uploading any content on
                the Platform, the User affirms that they either own the content
                or have obtained all necessary permissions, licenses, and
                consents to use and share the content on the platform.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.1.2.
                <span> </span>
              </span>
              <span>
                <span className="msoIns">
                  <ins>
                    The User retains full ownership of the content they upload
                    to the Platform, including any metadata or embedded
                    material, even if such content is used with consent to train
                    or improve the Lykstage AI Model. Granting permission for AI
                    training does not affect the User&apos;s ownership of their
                    original content.
                  </ins>
                </span>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.1.3.
                <span> </span>
              </span>
              <span>
                All content submitted to the platform remains the intellectual
                property of the respective content creators. However, by
                submitting content, you grant the platform a non-exclusive,
                royalty-free, worldwide, and perpetual license to use, display,
                reproduce, modify, adapt, and distribute the content solely for
                the purpose of operating and promoting the platform.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.1.4.
                <span> </span>
              </span>
              <span>
                <span className="msoIns">
                  <ins>
                    Any content, data, results, or outputs that are
                    independently generated by the Lykstage AI model, whether or
                    not such outputs are influenced by the User&apos;s uploaded
                    content, shall be deemed the sole property of the Company.
                    The User shall have no ownership or moral rights in any
                    AI-generated content, including derivative or synthesized
                    works produced by the Platform&apos;s proprietary models.
                  </ins>
                </span>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>14.2.</span>
              <span>Copyright Infringement Policy</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.2.1.
                <span> </span>
              </span>
              <span>
                copyright infringement notices in accordance with applicable
                laws.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.2.2.
                <span> </span>
              </span>
              <span>
                It is the responsibility of the User to ensure they own the
                copyright of the content that they upload.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.2.3.
                <span> </span>
              </span>
              <span>
                If the User believes that their copyrighted work has been used
                or copied in a way that constitutes copyright infringement,
                please provide the designated Copyright Agent with the following
                information:{' '}
              </span>
              <ol className="olTypei">
                <li>
                  A description of the copyrighted work that is claimed to have
                  been infringed.
                </li>
                <li>
                  Information about the location of the allegedly infringing
                  content on the platform.
                </li>
                <li>
                  User contact information, including name, address, telephone
                  number, and email address.
                </li>
                <li>
                  A statement by the User that the User has a good faith belief
                  that the use of the copyrighted material is not authorized by
                  the copyright owner, its agent, or the law.
                </li>
                <li>
                  A statement by the User, made under penalty of perjury, that
                  the information in your notice is accurate, and that you are
                  the copyright owner or authorized to act on the copyright
                  owner&apos;s behalf.
                </li>
              </ol>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.2.4.
                <span> </span>
              </span>
              <span>
                The Platform reserves the right to stop the monetization of the
                content that has been flagged for copyright violation till the
                infringement matter is resolved. The User shall be unable to
                redeem their Lyk Coins earned till the infringement matter is
                resolved, however the User shall continue to earn the Lyk Coins
                from viewing and creating Content.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.2.5.
                <span> </span>
              </span>
              <span>
                In case the User wishes to lift the restriction on their
                content, they must furnish proper documentation to prove their
                ownership of the copyright of the content to the below mentioned
                email address. The Platform&apos;s team shall examine such
                documents and provide their assessment on the same.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.2.6.
                <span> </span>
              </span>
              <span>
                The Platform will inform the allegedly infringing User of the
                copyright claim against them, if such a User does not respond
                within 14 days, the Content uploaded by them will be taken down
                immediately and all their monetization shall be ceased
                immediately.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.2.7.
                <span> </span>
              </span>
              <span>
                In case a Copyright Infringement is found to be true the User
                shall indemnify, defend, and hold harmless the Platform and the
                Company from any action taken by a third party.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.2.8.
                <span> </span>
              </span>
              <span>
                In case the User uploads content to which they do not own the
                copyright, the Platform shall pay the original owner the
                proceeds generated from the content.
              </span>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.2.9.
                <span> </span>
              </span>
              <span>The User can contact our team at the email address </span>
              <a href="mailto:ip@lykstage.com">
                <span>ip@lykstage.com</span>
              </a>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>14.3.</span>
              <span>Repeat Infringer Policy</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.3.1.
                <span> </span>
              </span>
              <span>
                The Platform reserves the right to terminate the accounts of
                users who repeatedly infringe on others&apos; copyrights.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.3.2.
                <span> </span>
              </span>
              <span>
                Users who have their accounts terminated for copyright
                infringement will be notified and provided with an opportunity
                to appeal the decision.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>14.4.</span>
              <span>Fair Use and Creative Commons</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.4.1.
                <span> </span>
              </span>
              <span>
                Users are encouraged to respect fair use principles and the
                terms of Creative Commons licenses when using copyrighted
                material on the platform.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.4.2.
                <span> </span>
              </span>
              <span>
                The Platform may provide tools or features to help users comply
                with fair use and Creative Commons licensing requirements.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>14.5.</span>
              <span>Content Removal and Disputes</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.5.1.
                <span> </span>
              </span>
              <span>
                The Platform reserves the right to remove or disable access to
                any content that is alleged to be infringing without prior
                notice.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.5.2.
                <span> </span>
              </span>
              <span>
                {' '}
                In case of disputes regarding copyright ownership or the removal
                of content, the Platform may provide a dispute resolution
                mechanism to resolve such issues.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.5.3.
                <span> </span>
              </span>
              <span>
                Such actions shall be taken only after a thorough review by the
                Platform of such Content and any discussion pertaining to
                removal shall be final.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>14.6.</span>
              <span>Copyright Education and Awareness</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                14.6.1.
                <span> </span>
              </span>
              <span style={{ fontFamily: '"Calibri",sans-serif !msorm' }}>
                <span>
                  The platform may offer educational resources and materials to
                  help users understand copyright laws and intellectual property
                  rights.
                </span>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textIndent: '-.35in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                14.6.2.
                <span> </span>
              </span>
              <span>
                <span className="msoIns">
                  <ins>
                    The Platform shall not be liable for not providing any such
                    material and the ultimate responsibility of being aware of
                    the Copyright Laws shall be solely o
                  </ins>
                </span>
                <span className="msoIns">
                  <ins>
                    n the User themselves. The Platform shall not be responsible
                    for the User&apos;s lack of knowledge on the Copyright and
                    other Intellectual Property Laws.
                  </ins>
                </span>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>14.7.</span>
              <span>Updates to Copyright Policy</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                The platform may update its copyright policy from time to time.
                Users will be notified of any material changes to the policy.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>15.</b>
                <span> </span>
              </span>
              <span>
                <b>Warranties of the User</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>15.1.</span>
              <span>
                The User hereby voluntarily accepts that the User agrees to the
                terms stated in this Agreement voluntarily and under sane
                conditions without any coercion or undue influence.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>15.2.</span>
              <span>
                The User agrees to having read and understood all the terms
                stated herein in this Agreement.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>15.3.</span>
              <span>
                The User warrants that the details provided herein is correct
                and accurate to the best of the User&apos;s knowledge.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>15.4.</span>
              <span>
                The User acknowledges that any Content uploaded by the User on
                the Platform is at their own risk and the Company or the
                Platform shall not be responsible for it.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>15.5.</span>
              <span>
                The User agrees to upload content that does not instigate
                violence in any society or in any country, does not defame any
                other person or entity, does not comment anything against the
                public policy under any other user&apos;s videos, does not use
                foul language or content that will be against the Applicable
                Laws and does not claim or violates any of the IPR of the other
                users or the Company.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>15.6.</span>
              <span>
                The User agrees using the Service does not give them ownership
                of or rights to any aspect of the Service, including user names
                or any other Content posted by others or the Company.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>15.7.</span>
              <span>
                If the User is using the Service on behalf of a company or
                organisation, and represents that the User has the authority to
                act on behalf of that entity, and that such entity accepts this
                Agreement in its entirety.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>15.8.</span>
              <span>
                The User agrees that the Services, including but not limited to
                the Website, the App, graphics, trademarks, and editorial
                Content, contain proprietary Content, information, and material,
                are owned by the Company and/or its licensors, including the
                customers, brands, and agencies, and is protected by applicable
                intellectual property and other laws, including but not limited
                to copyright. The User agree that the User shall not use such
                proprietary Content, information, or materials other than for
                the User&apos;s permitted use of the Services or in any manner
                that is inconsistent with the terms of this User Terms.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>15.9.</span>
              <span>
                The User agrees not to modify, rent, lease, loan, sell,
                distribute, or create derivative works based on the Services, in
                any manner, and the User shall not exploit the Services in any
                unauthorized way whatsoever.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>16.</b>
                <span> </span>
              </span>
              <span>
                <b>Rights of the Company</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>16.1.</span>
              <span>
                To store and process the information of the Users for providing
                better services, rights to alter any of the provisions mentioned
                herein.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>16.2.</span>
              <span>
                To terminate the user account of a user if found violating any
                of the provisions mentioned herein.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>16.3.</span>
              <span>
                To pull down videos from the Platform if found against the terms
                mentioned herein.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>16.4.</span>
              <span>
                The Company has the right to remove the User&apos;s Promotion
                (if any) from the Platform Services if they reasonably believe
                that the User Promotion does not comply with the Terms of
                Service or Applicable Laws.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>17.</b>
                <span> </span>
              </span>
              <span>
                <b>Spam, Deceptive Practices and Scam Policies</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>17.1.</span>
              <span>
                The Platform does not allow spam, scams, or other deceptive
                practices that take advantage of other Users, Content Creators
                and Viewers. The Platform also don&apos;t allow content where
                the main purpose is to trick others into leaving LYKSTAGE for
                another site.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>17.2.</span>
              <span>
                If the User finds content that violates this policy, they are
                urged to report such content by clicking on the “Report Video”
                If User finds a few videos or comments that they would like to
                report, they can report the User as well.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>For the Users Uploading Content</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>17.3.</span>
              <span>
                Do not post content on the Platform if it fits any of the
                descriptions noted below:
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                17.3.1.
                <span> </span>
              </span>
              <b>
                <span>Video Spam</span>
              </b>
              <span>
                : Content that is excessively posted, repetitive, or untargeted
                and does one or more of the following:
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '2.55in',
                textAlign: 'justify',
                textIndent: '-.55in',
                lineHeight: '150%',
              }}
            >
              <span>17.3.1.1.</span>
              <span>
                Promises viewers they&apos;ll see something but instead directs
                them off site.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '2.55in',
                textAlign: 'justify',
                textIndent: '-.55in',
                lineHeight: '150%',
              }}
            >
              <span>17.3.1.2.</span>
              <span>
                Gets clicks, views, or traffic off LYKSTAGE by promising viewers
                that they&apos;ll make money fast.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '2.55in',
                textAlign: 'justify',
                textIndent: '-.55in',
                lineHeight: '150%',
              }}
            >
              <span>17.3.1.3.</span>
              <span>
                Sends viewers to sites that spread harmful software, try to
                gather personal info, or other sites that have a negative
                impact.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                17.3.2.
                <span> </span>
              </span>
              <b>
                <span>Misleading Metadata or Thumbnails</span>
              </b>
              <span>
                : Using the title, thumbnails, description to trick users into
                believing the content is something it is not.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                17.3.3.
                <span> </span>
              </span>
              <b>
                <span>Scams</span>
              </b>
              <span>
                : Content offering cash gifts, “get rich quick” schemes, or
                pyramid schemes (sending money without a tangible product in a
                pyramid structure).
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                17.3.4.
                <span> </span>
              </span>
              <b>
                <span>Incentivization Spam</span>
              </b>
              <span>
                : Content that sells engagement metrics such as views, likes,
                comments, or any other metric on LYKSTAGE. This type of spam can
                also includes content where the only purpose is to boost
                subscribers, views, or other metrics.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                17.3.5.
                <span> </span>
              </span>
              <b>
                <span>Comments Spam</span>
              </b>
              <span>
                : Comments where the sole purpose is to gather personal info
                from viewers, misleadingly drive viewers off LYKSTAGE, or
                perform any of the prohibited behaviors noted above.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                17.3.6.
                <span> </span>
              </span>
              <b>
                <span>Repetitive comments</span>
              </b>
              <span>
                : Leaving large amounts of identical, untargeted or repetitive
                comments.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                17.3.7.
                <span> </span>
              </span>
              <b>
                <span>3rd party content</span>
              </b>
              <span>
                : Live streams intended to stream content that belongs to
                somebody else and are not corrected after repeated warnings of
                possible abuse. Channel owners should actively monitor their
                live streams and correct any potential issues in a timely
                manner.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>17.4.</span>
              <span>
                The Users are allowed to encourage viewers to subscribe, hit the
                like button, share, or leave a comment.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>17.5.</span>
              <span>
                If the content violates this policy or any other policy, clause
                or covenant in these Terms and Conditions, the Platform may
                suspend the violating User&apos;s monetization through the
                Reward System or terminate their or account.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>17.6.</span>
              <span>
                Remember these are just some examples, the User is encouraged
                not to post any such content which may violate this Policy.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>18.</b>
                <span> </span>
              </span>
              <span>
                <b>Impersonation Policy</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>18.1.</span>
              <span>
                Content intended to impersonate a person or channel is not
                allowed on LYKSTAGE. The Platform also enforces trademark holder
                rights. When a User Account, or content uploaded in the User
                Account, causes confusion about the source of goods and services
                advertised, it may not be allowed.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>18.2.</span>
              <span>
                If you see content that violates this policy, you can report
                such content by clicking on “Report Video”.If the User feels
                that theirs or another User&apos;s channel is being
                impersonated, or any User is using such means of impersonation
                to create fake engagement they can report the User
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>For the Users Uploading Content</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>18.3.</span>
              <span>
                Do not post content on LYKSTAGE if it fits any of the
                descriptions noted below:
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                18.3.1.
                <span> </span>
              </span>
              <b>
                <span>Account impersonation:</span>
              </b>
              <span>
                An Account that copies another Account&apos;s profile,
                background, or overall look and feel in such a way that makes it
                look like someone else&apos;s Account. The Account does not have
                to be 100% identical, as long as the intent is clear to copy the
                other Account.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                18.3.2.
                <span> </span>
              </span>
              <b>
                <span>Personal impersonation: </span>
              </b>
              <span>
                Content intended to look like someone else is posting it.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                18.3.3.
                <span> </span>
              </span>
              <b>
                <span>Fan Accounts:</span>
              </b>
              <span>
                If any User operates a fan account, they are encouraged to make
                sure they state so explicitly in their Account name. It should
                be obvious to their viewers that their channel doesn&apos;t
                represent the original creator, artist or entity their channel
                is celebrating.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>
                  19.
                  <span> </span>
                </span>
              </b>
              <b>
                <span>Fake Engagement Policy</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>19.1.</span>
              <span>
                LYKSTAGE doesn&apos;t allow anything that artificially increases
                the number of views, likes, comments, or other metrics either by
                using automatic systems or serving up videos to unsuspecting
                viewers or the use of Bot Accounts. Also, content that solely
                exists to incentivize viewers for engagement (views, likes,
                comments, etc) is prohibited.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>19.2.</span>
              <span>
                LYKSTAGE reserves the right to terminate and remove the account
                if the User is found committing any action that is contrary to
                the provisions of this policy.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>19.3.</span>
              <span>
                If the User hires someone to promote their account, their
                decisions may impact the User&apos;sAccount. Any method that
                violates our policies may result in content removal or Account
                termination, whether it&apos;s an action taken by the User or
                someone hired by the User.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>19.4.</span>
              <span>
                The Platform considers engagement to be legitimate when a human
                user&apos;s primary intent is to authentically interact with the
                content. The Platform considers engagement illegitimate, for
                example without limitation, when it results from coercion or
                deception, or when the sole purpose of the engagement is
                financial gain.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>19.5.</span>
              <span>
                If the User finds content that violates this policy, the User is
                encouraged to report it using the following link [Insert Report
                Page link]. If the User has found a few videos or comments that
                they would like to report, they can report the channel.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <b>
                <span>For the Users Uploading Content</span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.75in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>19.6.</span>
              <span>
                Do not post content on LYKSTAGE if it fits any of the
                descriptions noted below:
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                19.6.1.
                <span> </span>
              </span>
              <span>
                Links to or promotes third-party services that artificially
                inflate metrics like views, likes, and subscribers.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                19.6.2.
                <span> </span>
              </span>
              <span>
                Content linking to or promoting third-party view count or
                subscriber gaming websites or services.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                19.6.3.
                <span> </span>
              </span>
              <span>
                Offering to subscribe to another creator&apos;s Account only if
                they subscribe to theirAccount.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                19.6.4.
                <span> </span>
              </span>
              <span>
                Content featuring a creator purchasing their views from a third
                party with the intent of promoting the service.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                19.6.5.
                <span> </span>
              </span>
              <span>
                Any Account created by the Creator themselves to engage with
                their own content.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                19.6.6.
                <span> </span>
              </span>
              <span>
                This policy applies to videos, video descriptions, comments,
                live streams, and any other LYKSTAGE product or feature. Keep in
                mind that this isn&apos;t a complete list.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>19.7.</span>
              <span>
                If the User content violates this policy, the Platform will
                remove the content and send the User an email to let you know.
                If it cannot be verified that the link posted by you is safe,
                the Platform may remove the link.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>19.8.</span>
              <span>
                If this is the User&apos;s first time violating these Terms and
                Conditions, they will likely get a warning with no penalty to
                their channel. If it&apos;s not, then the Procedures laid down
                by the Content Moderation Clause will take effect.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>19.9.</span>
              <span>
                The Platform may terminate the account for repeated violations
                of the Community Guidelines or Terms of Service. The Platform
                may also terminate the account after a single case of severe
                abuse, or when the Account is dedicated to a policy violation.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpLast"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>20.</b>
                <span> </span>
              </span>
              <span>
                <b>Advertisements</b>
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>20.1.</span>
              <span style={{ color: 'black' }}>
                The Company hereby abides by all the applicable and amended
                advertising laws of the land in which the Platform operates and
                provides the advertising services.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpFirst"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>20.2.</span>
              <span>
                The advertisements may contain hyperlinks navigating the Users
                to a particular website. However, the User shall make sure that
                the same does not lead the User to the following:-
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                20.2.1.
                <span> </span>
              </span>
              <span>Pornographic websites.</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                20.2.2.
                <span> </span>
              </span>
              <span>Websites or apps that install malware.</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                20.2.3.
                <span> </span>
              </span>
              <span>Websites or apps used for phishing information.</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                20.2.4.
                <span> </span>
              </span>
              <span>
                {' '}
                Websites or apps that give unauthorized free access to content.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                20.2.5.
                <span> </span>
              </span>
              <span>
                Websites that raise funds for criminal or terrorist
                organizations.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                20.2.6.
                <span> </span>
              </span>
              <span>Websites containing Child Sexual Abuse Imagery.</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span>20.3.</span>
              <span>
                The Company complies with all the Applicable laws of land in
                which the advertisement services are provided on the Platform.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>20.4.</span>
              <span>
                Social Gear Inc., an affiliate of the Company, serves advertisements
                on the Platform on the Company's behalf. The Company does not share
                the User's information with Social Gear Inc. to build audiences or
                show the User advertising outside LYKSTAGE, and will not start doing
                so without notifying the User in advance and giving the User a way to
                opt out, as described in the Privacy Policy.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpLast"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>21.</b>
                <span> </span>
              </span>
              <span>
                <b>Payment Terms</b>
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>21.1.</span>
              <span style={{ color: 'black' }}>
                The Company shall be at a discretion to use third party services
                of payment aggregators and payment gateways for the payment
                mechanism.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>21.2.</span>
              <span style={{ color: 'black' }}>
                Such third parties may deploy their cookies on the Platform in
                order to provide better payment services and mechanisms.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>21.3.</span>
              <span style={{ color: 'black' }}>
                The User shall be able to select one of the payment options and
                shall enter the necessary and correct payment details.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>21.4.</span>
              <span style={{ color: 'black' }}>
                The User shall know that the Platform in no way records the
                payment details entered. It is directly stored by the associated
                third parties according to the terms and conditions available on
                their website.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>21.5.</span>
              <span style={{ color: 'black' }}>
                The Company shall not be held liable and shall always be
                considered harmless in case of there being any data breach or
                data leak of the payment details entered, constant lag or
                failure in payment process or for any other loss, potential loss
                or inconvenience caused to the User while initiating a
                payment.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpFirst"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpLast"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>22.</b>
                <span> </span>
              </span>
              <span>
                <b>Term, Account Termination and Suspension</b>
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>22.1.</span>
              <span style={{ color: 'black' }}>
                When the User signs up for the Service and agree to these Terms,
                the Agreement between the User and the Platform is formed, and
                the Agreement will come into effect. The term will continue for
                as long as the User have a user account or until the User or the
                Company terminates the Agreement in accordance with these terms,
                whichever happens first.{' '}
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>22.2.</span>
              <span style={{ color: 'black' }}>
                The Company reserves the right to terminate or suspend the
                User&apos;s account if the Company finds a committal of breach
                of this Agreement or the Company is required to do so to comply
                with a legal requirement or a court order or the Company
                believes there has been conduct that creates (or could create)
                liability or harm to any user, other third party, the Company or
                the affiliates of the Company.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>22.3.</span>
              <span style={{ color: 'black' }}>
                The Company shall notify the User with the reason for
                termination or suspension unless the Company reasonably believes
                that to do so would violate the law or the direction of a legal
                enforcement authority and/or would compromise an investigation
                and/or would compromise the integrity, operation or security of
                the Service and/or would cause harm to any user, other third
                party, the Company or the affiliates of the Company.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: '0in',
                marginRight: '0in',
                marginBottom: '0in',
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <span style={{ color: 'black' }}>22.4.</span>
              <span style={{ color: 'black' }}>
                If the User Account is Terminated, the access to the service
                shall be restricted; The User may continue using certain aspects
                of the Service (such as viewing only) without an account, and
                this Agreement will continue to apply to such use. If the User
                believes that the termination or suspension of their account has
                been made in error, they can approach the Grievance Officer.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpFirst"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>22.5.</span>
              <span>
                If you post content that encourages other users to violate our
                Terms of Service, the content may be removed, your account may
                be penalized, and in some cases your account may be terminated.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>22.6.</span>
              <span>
                If the User is found posting content previously removed for
                violating this Terms of Service or content from creators with a
                current restriction, or content from creators who have been
                terminated is considered circumvention under our Terms of
                Service.If the User posts such content, it may be removed, and
                your Account may also be penalized or terminated. This may also
                apply to other Accounts you own.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>23.</b>
                <span> </span>
              </span>
              <span>
                <b>Content Moderation Policy and Reporting Mechanism</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>23.1.</span>
              <span>
                The Platform is committed to maintaining a safe and welcoming
                environment for all our users. To achieve this goal, the
                Platform has implemented a robust content moderation system to
                promptly identify and remove illegal, harmful, or inappropriate
                content from the Platform. This content moderation policy aims
                to ensure compliance with applicable laws, protect the rights
                and safety of the users, and uphold the community standards.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>23.2.</span>
              <span>
                Prohibited Content: The Platform strictly prohibit the following
                types of content:{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.2.1.
                <span> </span>
              </span>
              <span>
                Content that violates any local, national, or international laws
                or regulations.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.2.2.
                <span> </span>
              </span>
              <span>
                Adult content, nudity, pornography, or sexually explicit
                material.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.2.3.
                <span> </span>
              </span>
              <span>
                Hate speech, discriminatory content, or content that promotes
                violence or harm towards individuals or groups based on their
                race, ethnicity, nationality, religion, gender, sexual
                orientation, disability, or any other protected
                characteristic.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.2.4.
                <span> </span>
              </span>
              <span>
                Content that encourages self-harm, suicide, or any dangerous
                activities.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.2.5.
                <span> </span>
              </span>
              <span>
                Misinformation or content that may cause harm, fear, or
                confusion to our users.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.2.6.
                <span> </span>
              </span>
              <span>Graphic or gratuitously violent content. </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.2.7.
                <span> </span>
              </span>
              <span>Harassment, bullying, or stalking of individuals. </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.2.8.
                <span> </span>
              </span>
              <span>
                Content that invades privacy or reveals sensitive personal
                information of others without their consent.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.2.9.
                <span> </span>
              </span>
              <span>
                Content that promotes or supports terrorism, hate groups, or
                extremist ideologies.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>23.3.</span>
              <span>Moderation Process</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.3.1.
                <span> </span>
              </span>
              <span>
                The Platform employs a combination of automated tools and human
                moderators to review and assess user-generated content.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.3.2.
                <span> </span>
              </span>
              <span>
                The Platform&apos;s content moderation team is trained to apply
                the guidelines consistently
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>23.4.</span>
              <span>User Reporting</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.4.1.
                <span> </span>
              </span>
              <span>
                The Platform encourage users to report any content that they
                believe violates the guidelines or community standards.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.4.2.
                <span> </span>
              </span>
              <span>
                Reports can be submitted through the reporting mechanisms, which
                are easily accessible on the platform.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.4.3.
                <span> </span>
              </span>
              <span>
                Some users may feel more comfortable reporting content
                anonymously. Therefore, the Platform offers an option to report
                content without revealing your identity. The User&apos;s
                anonymity will be respected throughout the reporting process.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.4.4.
                <span> </span>
              </span>
              <span>
                The User can report content through various channels, including
                but not limited to:
              </span>
              <ol className="olTypei">
                <li>
                  The report video button or flagging option available on each
                  post or piece of content.
                </li>
                <li>
                  The Platform&apos;s dedicated reporting form accessible
                  through the user settings or help center.
                </li>
                <li>
                  Sending an email to the support team at{' '}
                  <a href="mailto:legal@lykstage.com">legal@lykstage.com</a>
                </li>
              </ol>
            </p>

            <p
              className="MsoNormal"
              style={{
                marginBottom: '0in',
                textAlign: 'justify',
                lineHeight: '150%',
                border: 'none',
              }}
            >
              <b>
                <span style={{ color: 'black' }}> </span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpFirst"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.4.5.
                <span> </span>
              </span>
              <span>Swift Action</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                Once reported, the content moderation team reviews the content
                promptly and takes appropriate action within the 24 hours of
                receiving the report, including but not limited to:
              </span>
              <ol className="olTypei">
                <li>
                  <strong>Content Removal:</strong> Any content found to be in
                  violation of the guidelines will be promptly removed from the
                  platform.
                </li>
                <li>
                  <strong>Warning and Education:</strong> In certain cases,
                  users may receive warnings and educational messages to promote
                  adherence to the guidelines.
                </li>
                <li>
                  <strong>Account Suspension:</strong> In more severe cases, the
                  Platform may temporarily suspend user accounts pending further
                  investigation.
                </li>
                <li>
                  <strong>Account Termination:</strong> Repeated violations or
                  egregious content may result in permanent account termination.
                </li>
                <li>
                  <strong>Subscription Plan Cancellation:</strong> If any
                  content of the User violates these Terms, the Platform may
                  cancel the Subscription Plan of the User.
                </li>
              </ol>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.5.
                <span></span>
              </span>
              <b>
                <span>Confidentiality and Privacy: </span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.5.1.
                <span> </span>
              </span>
              <span>
                The Platform respects your privacy and confidentiality. All
                reports will be handled with utmost discretion.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.5.2.
                <span> </span>
              </span>
              <span>
                Please note that while the Platform will do the best to keep the
                User identity confidential, there may be instances where
                disclosure is necessary to investigate and resolve the reported
                issue properly.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.6.
                <span></span>
              </span>
              <b>
                <span>Appeal Process: </span>
              </b>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.6.1.
                <span> </span>
              </span>
              <span>
                If a user believes their content was wrongfully removed or their
                account was actioned in error, they have the right to appeal the
                decision.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.6.2.
                <span> </span>
              </span>
              <span>Appeals can be submitted through our following Email </span>
              <span>
                Address :{' '}
                <a href="mailto:legal@lykstage.com">legal@lykstage.com</a>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.6.3.
                <span> </span>
              </span>
              <span>
                Ensure that the subject is clearly mentioned and the appeal is
                made in clear and unambiguous terms
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.85in',
                textAlign: 'justify',
                textIndent: '-.35in',
                lineHeight: '150%',
              }}
            >
              <span>
                23.6.4.
                <span> </span>
              </span>
              <span>
                The Platform&apos;s Content Moderation team shall review the
                appeal and act accordingly
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>24.</b>
                <span> </span>
              </span>
              <span>
                <b>Anti Money Laundering Policy</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>24.1.</span>
              <span>
                The Company is in compliance with all the applicable laws of
                Anti-Money Laundering of the land in which the Services are
                being provided.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>24.2.</span>
              <span>
                The Company strictly condemns all acts of Money Laundering and
                any User found to be committing any acts which fall under the
                purview of Money Laundering which causes damage to the Company
                or any third party, shall be persecuted as per the clauses and
                covenants of these Terms and Conditions.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>24.3.</span>
              <span>
                Any and all kind of charges levied on the Users by any Third
                Party or other User of the Platform shall be the responsibility
                of the User alone and User shall bear all the costs and charges
                that shall be applicable, the Platform or the Company shall in
                no way be responsible legally or financially for such actions by
                the Users.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>25.</b>
                <span> </span>
              </span>
              <span>
                <b>Communication</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>25.1.</span>
              <span>
                By creating an account on the Platform, the User agrees to
                receive communications from us including e-mails, messages,
                texts, calls, notifications, WhatsApp Messages, etc.The User may
                unsubscribe from the mailing list, but even after unsubscribing
                from the mailing list, the User may continue to receive
                notification emails related to security, password reminders,
                connection activities, engagements, and other Platform updates.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>26.</b>
                <span> </span>
              </span>
              <span>
                <b>Governing Laws and Dispute Resolution</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>26.1.</span>
              <span style={{ color: 'black' }}>
                The terms mentioned herein shall be governed by the Applicable
                Laws of the land in which the Platform Services are provided or
                where the Company or any of its affiliates functions.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>26.2.</span>
              <span style={{ color: 'black' }}>
                All Disputes between the User and the Company in relation to
                this Agreement shall be resolved by the means of Arbitration in
                accordance with the Commercial Arbitration Rules, as amended
                from time to time, of the American Arbitration Association (the
                “AAA”).
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>26.3.</span>
              <span style={{ color: 'black' }}>
                The arbitration proceedings shall take place in the State of
                California, USA. Judgment upon any award rendered by the
                arbitrators may be entered into any court having competent
                jurisdiction without any right of appeal.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>27.</b>
                <span> </span>
              </span>
              <span>
                <b>Third Party Links</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>27.1.</span>
              <span>
                The Platform may contain links to third-party websites and
                online services that are not owned or controlled by the Company.
                The Company has no control over, and assumes no responsibility
                for, such websites and online services. The User must be aware
                when they leave the Service; the Company suggests the User to
                read the terms and privacy policy of each third-party website
                and online service that they visit.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>28.</b>
                <span> </span>
              </span>
              <span>
                <b>Indemnity</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>28.1.</span>
              <span>
                The user shall indemnify and hold harmless the Company and its
                affiliates for violating any of these provisions stated herein.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>29.</b>
                <span> </span>
              </span>
              <span>
                <b>Survival Clause</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>29.1.</span>
              <span>
                Upon termination of this Notice, the following clauses shall
                remain in force:-
              </span>
              <ol className="olTypei">
                <li>Eligibility of the User</li>
                <li>Cookies</li>
                <li>Privacy Policy</li>
                <li>IPR</li>
                <li>Indemnity</li>
                <li>Prohibition on Unauthorized Automated Access, Scraping, and Direct CDN Access</li>
              </ol>
            </p>

            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>30.</b>
                <span> </span>
              </span>
              <span>
                <b>Severability</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                If any part of these Conditions has been declared as illegal,
                the other parts of this Agreement shall remain in force.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>31.</b>
                <span> </span>
              </span>
              <span>
                <b>Independent Contractor Relationship</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                The Parties hereto are independent contractors, and nothing
                contained herein shall be interpreted as creating any
                relationship other than that of independent contracting Parties.
                The Parties shall not be construed as being partners, joint
                ventures, shareholders, employers/employees, agents/servants.
                The User has no power or authority to bind the Platform to any
                obligation, agreement, debt, or liability. The User shall not
                hold itself out as an agent or representative of the Platform.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>32.</b>
                <span> </span>
              </span>
              <span>
                <b>About the Agreement</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>32.1.</span>
              <span>
                The Company may amend this Agreement to reflect changes to the Services,
                for legal, regulatory or security reasons, or to prevent abuse or harm.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>32.2.</span>
              <span>
                If the Company materially changes this Agreement, it will
                notify the User through an in-app notice and by email (if the User has provided one)
                at least 30 days before the changes take effect, and will post the updated Agreement
                on this page with a new Effective Date. Changes that are not material, such as
                corrections and clarifications, take effect when published. The Company will not
                treat the User's continued use of the Service as consent to any new use of the User's
                information that requires consent under applicable law.{' '}
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>32.3.</span>
              <span>
                If the User does not agree to the new terms, they may choose to
                remove any Content they uploaded and stop using the Service.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>32.4.</span>
              <span>
                If it turns out that a particular term of this Agreement is not
                enforceable for any reason, this will not affect any other
                terms.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>32.5.</span>
              <span>
                If the user fails to comply with this Agreement and the Company
                does not take immediate action, this does not mean that they are
                giving up any rights that they may have to take action on such
                breach.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>32.6.</span>
              <span>
                Any dispute with respect to any clauses, covenants or statements
                in these Terms of Service shall be dealt with as per the laws of
                California regardless of the location or territory that the User
                resides in as described in Clause 25.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>33.</b>
                <span> </span>
              </span>
              <span>
                <b>Notice</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.55in',
                textAlign: 'justify',
                textIndent: '-.3in',
                lineHeight: '150%',
              }}
            >
              <span>33.1.</span>
              <span style={{ color: 'black' }}>
                A notice to the User shall be considered to be effective when
                the Company sends it to the last email or physical address the
                User gave the Company or when posted on our Website. Any notice
                to the Company or the Platform shall be effective when delivered
                to the Company along with a copy to our legal counsel: Attn.
                Legal Department, LYK Inc 913 N. Market Street, Suite 300,
                Wilmington, DE 19801, or any address as the Company may later
                post on the Platform
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                textIndent: '-.25in',
                lineHeight: '150%',
              }}
            >
              <span>
                <b>34.</b>
                <span> </span>
              </span>
              <span>
                <b>Grievance Officer</b>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                In case of there being any grievance regarding the Platform, the
                User may contact the Grievance Officer through the following
                contact details:-
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>Name: Legal Department</span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                E-Mail ID:{' '}
                <a href="mailto:legal@lykstage.com">legal@lykstage.com</a>
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                Registered Address: Attn. Legal Department, LYK Inc 913 N.
                Market Street, Suite 300, Wilmington, DE 19801
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                The Grievance Officer will acknowledge your grievance
                promptly and respond within 90 days of receiving it.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>
                If the grievance remains unresolved, the matter shall be dealt
                with by the state and federal courts in California, USA, and
                each party will be subject to the jurisdiction of those courts.
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span></span>
            </p>
            <p
              className="MsoListParagraphCxSpLast"
              style={{
                marginLeft: '.25in',
                textAlign: 'justify',
                lineHeight: '150%',
              }}
            >
              <span>THANK YOU!</span>
            </p>
            <p
              className="MsoNormal"
              style={{ textAlign: 'justify', lineHeight: '150%' }}
            >
              <span></span>
            </p>
            </>

          </div>
        </Box>

        <section>
          <Footer />
        </section>
      </div>
    </>
  )
}
